import React, { useEffect, useRef, useState } from "react";
import patient from "../../assets/img/patient.jpg";
import rightArrow from "../../assets/img/arrow-right.svg";
import upload_icon from "../../assets/img/upload_icoon.svg";
import tooltip_info_icon from "../../assets/img/tooltip_info_icon.svg";
import uploadIcon from "../../assets/img/upload-icon.svg"
import reportIcon from "../../assets/img/genaret-report.svg"
import { IoMdAdd } from "react-icons/io";
import { BsList } from "react-icons/bs";
import { RxDashboard } from "react-icons/rx";
import { IoCheckmarkDoneOutline, IoEyeSharp } from "react-icons/io5";
import { LuUpload } from "react-icons/lu";
import { AiOutlineClose } from "react-icons/ai";
import { IoMdMore } from "react-icons/io";
import { MdOutlineRecommend } from "react-icons/md";

import { MdOutlineFileUpload } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { AiOutlineAudio } from "react-icons/ai";
import { IoDocumentTextOutline } from "react-icons/io5";
import { SiSecurityscorecard } from "react-icons/si";
import { TbSend } from "react-icons/tb";
import { FaUserInjured } from "react-icons/fa";

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

// import arrorRight from "../../assets/img/arrow-right.svg"
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  patientInformation /*patientManage, patientMedicineRecommendation, patientReport*/,
} from "../../redux/action";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import arrorRight from "../../assets/img/arrow-right.svg";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { CallWithAuth } from "../../action/apiActions";
import {
  ADMINTEMPLATE,
  CHECK_PATIENT_REPORT_STATUS,
  DELETE_DOCUMENT,
  DELETE_PATIENT,
  GET_PATIENT_RELATIVES_API_URL,
  GET_PROMPTS,
  PATIENT_ASSESSMWNT_RECOMMENDED,
  PATIENT_ASSESSMWNT_RECOMMENDED_STREAM,
  PATIENT_ASSESSMWNT_SUMMARY,
  PATIENT_AUDIO_API_URL,
  PATIENT_INFORMATION_API_URL,
  PATIENT_INTAKE_FROM_RESEND,
  UPLOAD_CLICNICAL_INTAKE_DOC,
  UPLOAD_CLICNICAL_INTAKE_FILE,
  UPLOAD_PATIENT_REPORT_RECORD_SESSION,
  UPLOAD_PATIENT_REPORT_RECORD_SESSION_SAVE,
} from "../../action/apiPath";
import { showToast } from "../../util/toastHelper";
import Webcam from "react-webcam";
import { base64ToFile } from "../../util/base64ToFile";
import {
  DOCTORASSESMENTINFORMATIONPAGE,
  PATIENTRELATIVESINFORMATION,
  RECORDINGINFORMATIONPAGE
} from "../../util/path";
import {
  record_sessions_assessment,
  record_sessions_clinical_interview,
  record_sessions_formulation,
} from "../../util/constant";
import {
  createShortNameFile,
  createShortNameFileDoc,
  errorMessageCreate,
  fileName,
  getFileType,
  safeMarkedWrapper,
} from "../../util/custom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { LoaderIndex } from "../../components/Loader/LoaderIndex";
import { Tabs, Tab, Box } from "@mui/material";
import { Tooltip as ReactTooltip } from "react-tooltip";
import PromptEditor from "../../components/PromptEditor/Index";
import { marked } from "marked";
import mutemic from '../../assets/img/unmute-mic.svg';
import { convertWebmToMp3 } from "../../components/audioConverter/mp3Converter";
import axios from "axios";
import { GET_USER } from "../../action/apiPath";
import { HiOutlineTemplate } from "react-icons/hi";

import UploadReportModal from "../patientInformation/UploadReportModal";


const MySwal = withReactContent(Swal);

const categoryStatic = [
  {
    id: "6f1bf9f2-3f09-465b-9884-d657261687f5",
    name: "Report Type A",
    created_at: "2024-11-05T06:49:58.156Z",
    updated_at: "2024-11-05T06:49:58.156Z",
  },
  {
    id: "91081fbf-b1d2-4505-83e5-de95385588fd",
    name: "Report Type B",
    created_at: "2024-11-05T06:53:29.366Z",
    updated_at: "2024-11-05T06:53:29.366Z",
  },
  {
    id: "0433fd14-090c-4724-bc51-fcf35923819a",
    name: "Report Type C",
    created_at: "2024-11-05T06:53:33.298Z",
    updated_at: "2024-11-05T06:53:33.298Z",
  },
];
// function MyVerticallyCenteredModal(props) {
function MyVerticallyCenteredModal({ onsuccess, ...props }) {
  const navigate = useNavigate();
  const [audio, setAudio] = React.useState(null);
  const [audioError, setAudioError] = React.useState(null);

  const [assessmentaudio, setAssessmentAudio] = React.useState(null);
  const [formulationaudio, setFormulationAudio] = React.useState(null);
  const [reportsAudio, setReportsAudio] = useState([]);

  const [dropdownOptions] = useState(categoryStatic);
  const [docs, setDocs] = useState([
    { doc: null, status: "not_uploaded", category: "" },
  ]);
  const [getErrorDoc, setErrorDoc] = useState("");
  const [clientIntakedragging, setDraggingClinicalIntakeFrom] = useState(false);
  const [assesmentFromdragging, setDraggingAssesmentFromFrom] = useState(false);
  const [formulationFromdragging, setDraggingFormulationFrom] = useState(false);
  const [getdropragging, setDraggingDocfile] = useState(false);
  const [isDocsLoading, setIsDocsLoading] = useState(false);

  const [initialValues, setInitialValues] = useState({
    clinical_interview: "",
    // assessment: "",
    formulation: "",
    mse: "",
  });
  const [uploadedRecordSession, setUploadedRecordSession] = useState({
    clinical_interview: "",
    // assessment: "",
    formulation: "",
    mse: "",
  });
  const [getUploadedReport, setUploadedReport] = useState([]);
  const [getErros, setErrors] = useState({});
  const [isConfirmed, setIsConfirmed] = useState(null);
  const webcamRef = useRef(null);
  // console.log("============>", files, docs)
  const [imageSrc, setImageSrc] = useState(null);
  const [facialImageFile, setFacialImageFile] = useState("");
  const [uploadedFacialImageFile, setUploadedFacialImageFile] = useState(null);
  const [hasPatientFaceImage, setHasPatientFaceImage] = useState(true);
  const [patientFaceImage, setPatientFaceImage] = useState("");

  const [isSubmit, setIsSubmit] = useState(false);

  const [assesment_list, setAssessmentList] = useState([]);

  const [uploadedFiles, setUploadedFiles] = useState({});
  const [dragging, setDragging] = useState({});
  const [uploadedassessmentFilesStatus, setUploadedassessmentFilesStatus] =
    useState({});

  const [isLoadingModalData, setisLoadingModalData] = useState(false);
  const [isuploadclinicalinterView, setIsuploadclinicalinterView] =
    useState(false);
  const [isuploadformulation, setIsuploadformulation] = useState(false);
  const [isuploadmse, setIsuploadMse] = useState(false);


  const [hasClickedSubmit, sethasClickedSubmit] = useState(false);
  const [tab_value, setTabValue] = useState(0);
  const [audioMse, setAudioMse] = useState(null);

  const [doctorAssesment, setDoctorAssesment] = useState([
    { doc: null, status: "not_uploaded", category: "" },
  ]);

  useEffect(() => {
    if (props.count > 0) {
      sethasClickedSubmit(false);
      // console.log("props=====>", props?.patientInformation);
      if (
        props?.patientInformation?.face_image != "" &&
        props?.patientInformation?.face_image != null
      ) {
        // console.log("face_image=====>", props?.patientInformation?.face_image);
        // setHasPatientFaceImage(true);
        setPatientFaceImage(props?.patientInformation?.face_image);
      } else {
        // setHasPatientFaceImage(false);
        setPatientFaceImage("");
      }
      setUploadedFacialImageFile(
        props?.patientInformation?.dr_uploaded_face_image
      );
      getPatientAllInformation(props);

      if (props?.patientInformation?.record_sessions.length) {
        let uploaded_record_sessions =
          props?.patientInformation?.record_sessions;
        // console.log("70", props?.patientInformation?.record_sessions);
        let clinical_interview = uploaded_record_sessions?.filter((item, i) => {
          return item.session_type == record_sessions_clinical_interview;
        });
        let clinical_interview_file_path = "";
        if (clinical_interview?.length) {
          clinical_interview_file_path =
            clinical_interview[0]["file"] != ""
              ? clinical_interview[0]["file"]
              : "";
        }

        /*for assesment file*/
        let assessment = uploaded_record_sessions?.filter((item, i) => {
          return item.session_type == record_sessions_assessment;
        });
        let assessment_file_path = "";
        if (assessment?.length) {
          assessment_file_path =
            assessment[0]["file"] != "" ? assessment[0]["file"] : "";
        }
        /* end for assesment file*/

        /*for formulation file*/
        let formulation = uploaded_record_sessions?.filter((item, i) => {
          return item.session_type == record_sessions_formulation;
        });
        let formulation_file_path = "";
        if (formulation?.length) {
          formulation_file_path =
            formulation[0]["file"] != "" ? formulation[0]["file"] : "";
        }
        /* end for formulation file*/

        // console.log("clinical_interview_file_path", clinical_interview_file_path);
        // setUploadedRecordSession((prevState) => ({
        //   ...prevState,
        //   clinical_interview: clinical_interview_file_path,
        //   assessment: assessment_file_path,
        //   formulation: formulation_file_path,
        // }));
      } else {
        setUploadedRecordSession((prevState) => ({
          ...prevState,
          clinical_interview: "",
          assessment: "",
          formulation: "",
        }));
        setUploadedReport([]);
      }

      setDocs([{ doc: null, status: "not_uploaded", category: "" }]);
      setDocs([{ doc: null, status: "not_uploaded", category: "" }]);
      setInitialValues((prevState) => ({
        ...prevState,
        clinical_interview: "",
        assessment: "",
        formulation: "",
      }));
      setErrors((prevState) => ({
        ...prevState,
        clinical_interview: "",
        assessment: "",
        formulation: "",
      }));
      setAssessmentAudio(null);
      setFormulationAudio(null);
      setAudio(null);
      setErrorDoc("");
    }
    // setFacialImageFile(null);
    setImageSrc(null);
    setIsConfirmed(null);
    // console.log('106======>',props.count);
  }, [props.count]);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      const parentDiv = event.target.parentElement;

      if (parentDiv) {
        if (
          (parentDiv.className.includes("modal-open") ||
            parentDiv.className.includes("modal-header")) &&
          !parentDiv.className.includes("swal2-shown")
        ) {
          setFacialImageFile("");
          setImageSrc(null);
          setIsConfirmed(null);
          setErrors((prevState) => ({
            ...prevState,
            clinical_interview: "",
            assessment: "",
            formulation: "",
          }));
          setInitialValues((prevState) => ({
            ...prevState,
            clinical_interview: "",
            assessment: "",
            formulation: "",
          }));
          setUploadedRecordSession((prevState) => ({
            ...prevState,
            clinical_interview: "",
            assessment: "",
            formulation: "",
          }));
          setUploadedReport([]);
          setUploadedFacialImageFile(null);
        }
      }
    };
    // Add event listener
    document.addEventListener("click", handleDocumentClick);
    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  /**
   * Fetches all patient information including relatives' data
   * and sets the uploaded reports state.
   *
   * @param {Object} props - The properties object containing patient ID.
   */
  const [uploadedRecordSeesion, setPatientUploadedRecordSession] = useState([]);
  const getPatientAllInformation = async (props) => {
    try {
      setisLoadingModalData(true);
      // Construct the API endpoint URL with patient ID
      const url = `${GET_PATIENT_RELATIVES_API_URL}/${props.patientid}/?extra=true`;

      // Make an authenticated GET request to the API
      const response = await CallWithAuth("GET", url);

      // Check if the response status is successful
      if (response?.res?.data?.statusCode === 200) {
        // Set the uploaded reports state with the fetched data
        setUploadedReport(response?.res?.data?.data?.reports);
        setAssessmentList(response?.res?.data?.data?.assessments);
        setPatientUploadedRecordSession(response?.res?.data?.data?.record_sessions);
      } else {
        // If response is not successful, set uploaded reports to an empty array
        setUploadedReport([]);
      }
    } catch (error) {
      // In case of an error, set uploaded reports to an empty array and log the error
      setUploadedReport([]);
      console.error("Error fetching patient information:", error);
    }
    setisLoadingModalData(false);
  };
  /**
   * Handles file change event for audio file upload input.
   * If the uploaded file is not an audio file (MP3, WAV, or M4A), display a warning toast.
   * If the file is valid, call the API to upload the file and update the state with the uploaded file URL.
   * If there is an error during the API call, display an error toast.
   * @param {Event} e - The event object from the file change event.
   */
  const handleFileChange = async (e, type) => {
    const { files } = e.target;
    const file = files[0];

    // Check if the uploaded file is an audio file (MP3, WAV, or M4A)
    if (
      file &&
      ![".mp3", ".wav", ".m4a", '.pdf'].includes(file.name.slice(-4).toLowerCase())
    ) {
      // Display a warning toast if the uploaded file is not an audio file
      toast.warn("Only MP3, WAV, and M4A formats are supported for audio.", {
        autoClose: 2000,
        position: "bottom-right",
      });
      return;
    }
    console.log("type", type);
    if (type == "clinical_interview") {
      setIsuploadclinicalinterView(true);
    } else if (type == "formulation") {
      setIsuploadformulation(true);
    } else if (type == 'mse') {
      setIsuploadMse(true);
    }
    // Call the API to upload the file
    const response = await apiCallFileUpload(file, "clinical_interview");

    // Check if the API call was successful
    if (response?.res?.data?.statusCode === 200) {
      // Update the state with the uploaded file URL
      setInitialValues((prev) => ({
        ...prev,
        clinical_interview: response?.res?.data?.data?.file_url,
      }));
      setAudio(file);
      setErrors((prev) => ({ ...prev, clinical_interview: "" }));
    } else {
      // Display an error toast if there was an error during the API call
      // console.log( response?.res?.data?.message);

      setAudio(null);
      setErrors((prev) => ({
        ...prev,
        clinical_interview: response?.res?.data?.message,
      }));

      // toast.error(response?.res?.data?.message, {
      //   autoClose: 2000,
      //   position: "bottom-right",
      // });
      showToast("error", response?.res?.data?.message);
    }

    if (type == "clinical_interview") {
      setIsuploadclinicalinterView(false);
    } else if (type == "formulation") {
      setIsuploadformulation(false);
    } else if (type == 'mse') {
      setIsuploadMse(false);
    }
  };

  const handleFileChangeMse = async (e, type) => {
    const { files } = e.target;
    const file = files[0];

    // Check if the uploaded file is an audio file (MP3, WAV, or M4A)
    if (
      file &&
      ![".mp3", ".wav", ".m4a", '.pdf'].includes(file.name.slice(-4).toLowerCase())
    ) {
      // Display a warning toast if the uploaded file is not an audio file
      toast.warn("Only MP3, WAV, and M4A formats are supported for audio.", {
        autoClose: 2000,
        position: "bottom-right",
      });
      return;
    }
    console.log("type", type);
    if (type == "clinical_interview") {
      setIsuploadclinicalinterView(true);
    } else if (type == "formulation") {
      setIsuploadformulation(true);
    } else if (type == 'mse') {
      setIsuploadMse(true);
    }
    // Call the API to upload the file
    const response = await apiCallFileUpload(file, "mse");

    // Check if the API call was successful
    if (response?.res?.data?.statusCode === 200) {
      // Update the state with the uploaded file URL
      setInitialValues((prev) => ({
        ...prev,
        mse: response?.res?.data?.data?.file_url,
      }));
      setAudioMse(file);
      setErrors((prev) => ({ ...prev, mse: "" }));
    } else {
      // Display an error toast if there was an error during the API call
      // console.log( response?.res?.data?.message);

      setAudioMse(null);
      setErrors((prev) => ({
        ...prev,
        mse: response?.res?.data?.message,
      }));

      // toast.error(response?.res?.data?.message, {
      //   autoClose: 2000,
      //   position: "bottom-right",
      // });
      showToast("error", response?.res?.data?.message);
    }

    if (type == "clinical_interview") {
      setIsuploadclinicalinterView(false);
    } else if (type == "formulation") {
      setIsuploadformulation(false);
    } else if (type == 'mse') {
      setIsuploadMse(false);
    }
  };

  const handleDropClinicalIntakeFrom = async (e, index) => {
    e.preventDefault();
    setDraggingClinicalIntakeFrom(false);

    // Get the dropped files
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      // Simulate onChange for the input file
      const event = {
        target: {
          name: `doc-${index}`,
          files,
        },
      };
      await handleFileChange(event, "clinical_interview");
    }
  };


  // Handle drag over to allow dropping
  const handleDragOverClinicalIntakeFrom = (e) => {
    e.preventDefault();
    setDraggingClinicalIntakeFrom(true);
  };


  // Handle drag leave
  const handleDragLeaveClinicalIntakeFrom = () => {
    setDraggingClinicalIntakeFrom(false);
  };
  /**
   * Handles file change event for assessment audio file upload input.
   * Validates the file type, uploads it via the API, and updates the state accordingly.
   * Displays a toast notification for any errors or warnings.
   *
   * @param {Event} e - The event object from the file change event.
   */

  const handleDropMseFrom = async (e, index) => {
    e.preventDefault();
    setDraggingClinicalIntakeFrom(false);

    // Get the dropped files
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      // Simulate onChange for the input file
      const event = {
        target: {
          name: `doc-${index}`,
          files,
        },
      };
      await handleFileChangeMse(event, "mse");
    }
  }

  const handleDragOverMseFrom = (e) => {
    e.preventDefault();
    setDraggingClinicalIntakeFrom(true);
  };
  const handleDragLeaveMseFrom = () => {
    setDraggingClinicalIntakeFrom(false);
  };
  const handleAssesmentFileChange = async (e) => {
    const { files } = e.target;
    const file = files[0];

    // Check if the uploaded file is an audio file (MP3, WAV, or M4A)
    if (
      file &&
      ![".mp3", ".wav", ".m4a"].includes(file.name.slice(-4).toLowerCase())
    ) {
      // Display a warning toast if the uploaded file is not an audio file
      // toast.warn("Only MP3, WAV, and M4A formats are supported for audio.", {
      //   autoClose: 2000,
      //   position: "bottom-right",
      // });
      showToast(
        "warning",
        "Only MP3, WAV, and M4A formats are supported for audio."
      );

      return;
    }

    // Call the API to upload the file
    const response = await apiCallFileUpload(file, "assessment");

    // Check if the API call was successful
    if (response?.res?.data?.statusCode === 200) {
      // Update the state with the uploaded file URL
      setInitialValues((prev) => ({
        ...prev,
        assessment: response?.res?.data?.data?.file_url,
      }));
      setAssessmentAudio(file);
      setErrors((prev) => ({ ...prev, assessment: "" }));
    } else {
      console.log(response?.res?.data?.data?.message);

      // Display an error toast if there was an error during the API call
      setAssessmentAudio(null);
      setErrors((prev) => ({
        ...prev,
        assessment: response?.res?.data?.message,
      }));

      // toast.error(response?.res?.data?.message, {
      //   autoClose: 2000,
      //   position: "bottom-right",
      // });
      showToast("error", response?.res?.data?.message);
    }
  };

  /**
   * Handles file change event for formulation audio file upload input.
   * If the uploaded file is not an audio file (MP3, WAV, or M4A), display a warning toast.
   * If the file is valid, call the API to upload the file and update the state with the uploaded file URL.
   * If there is an error during the API call, display an error toast.
   * @param {Event} e - The event object from the file change event.
   */
  const handleChangeFormulationFile = async (e) => {
    const { files } = e.target;
    const file = files[0];

    // Check if the uploaded file is an audio file (MP3, WAV, or M4A)
    if (
      file &&
      ![".mp3", ".wav", ".m4a", '.pdf'].includes(file.name.slice(-4).toLowerCase())
    ) {
      // Display a warning toast if the uploaded file is not an audio file
      toast.warn("Only MP3, WAV, and M4A formats are supported for audio.", {
        autoClose: 2000,
        position: "bottom-right",
      });
      return;
    }
    setIsuploadformulation(true);
    // Call the API to upload the file
    const response = await apiCallFileUpload(file, "formulation");

    // Check if the API call was successful
    if (response?.res?.data?.statusCode === 200) {
      // Update the state with the uploaded file URL
      setInitialValues((prev) => ({
        ...prev,
        formulation: response?.res?.data?.data?.file_url,
      }));
      setErrors((prev) => ({ ...prev, formulation: "" }));

      setFormulationAudio(file);
    } else {
      // Display an error toast if there was an error during the API call
      setFormulationAudio(null);
      setErrors((prev) => ({
        ...prev,
        formulation: response?.res?.data?.message,
      }));
      toast.error(response?.res?.data?.message, {
        autoClose: 2000,
        position: "bottom-right",
      });
    }
    setIsuploadformulation(false);
    // setFormulationAudio(file);
  };

  const handleDropFormulationFrom = (e, index) => {
    e.preventDefault();
    setDraggingAssesmentFromFrom(false);

    // Get the dropped files
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      // Simulate onChange for the input file
      const event = {
        target: {
          name: `doc-${index}`,
          files,
        },
      };
      handleChangeFormulationFile(event);
    }
  };
  // Handle drag over to allow dropping
  const handleDragOverFormulationFrom = (e) => {
    e.preventDefault();
    setDraggingFormulationFrom(true);
  };

  // Handle drag leave
  const handleDragLeaveFormulationFrom = () => {
    setDraggingFormulationFrom(false);
  };

  /**
   * Upload a file to the server with a specified session type.
   *
   * @param {File} file - The file to be uploaded.
   * @param {string} type - The session type for the file.
   * @returns {Promise<Object>} - The server response.
   */
  const apiCallFileUpload = async (file, type) => {
    // Create a new FormData object and append the file and session type
    const formdata = new FormData();
    formdata.append("file", file);
    formdata.append("session_type", type);

    // Send the form data to the server using a POST request
    return await CallWithAuth(
      "POST",
      UPLOAD_PATIENT_REPORT_RECORD_SESSION,
      formdata
    );
  };

  const handleUploadForDocs = async (index) => {
    const newDocs = [...docs];
    setIsDocsLoading(true);
    const response = await handleUploadDocFile(newDocs[index].doc);
    // console.log(response);
    let message = errorMessageCreate(response?.res?.data?.message);

    if (response?.res?.data?.statusCode === 200) {
      const fileType = newDocs[index].doc.type;
      let fileTypeName = "Document";
      if (fileType.startsWith("image/")) {
        fileTypeName = "Image";
      }

      newDocs[index].status = "uploaded";
      newDocs[index].doc = response?.res?.data?.data?.file_url;
      newDocs[index].category = categoryStatic[0].id;
      newDocs[index].fileTypeName = fileTypeName;
      setDocs(newDocs);
      // showToast('success', message);
      toast.success(response?.res?.data?.message, {
        autoClose: 2000,
        position: "bottom-right",
      });
    } else {
      // console.log('282',response?.res?.data?.message);

      // console.log(response?.res?.data?.message);
      setErrorDoc(response?.res?.data?.message);
      // alert(response?.res?.data?.message);
      toast.error(response?.res?.data?.message, {
        autoClose: 2000,
        position: "bottom-right",
      });
    }
    setIsDocsLoading(false);
  };

  // const handleUploadForAssesmentDocs = async (index) => {
  //   const newDocs = [...doctorAssesment];
  //   setIsDocsLoading(true);
  //   const response = await handleUploadDocFile(newDocs[index].doc);
  //   // console.log(response);
  //   let message = errorMessageCreate(response?.res?.data?.message);

  //   if (response?.res?.data?.statusCode === 200) {
  //     const fileType = newDocs[index].doc.type;
  //     let fileTypeName = "Document";
  //     if (fileType.startsWith("image/")) {
  //       fileTypeName = "Image";
  //     }

  //     newDocs[index].status = "uploaded";
  //     newDocs[index].doc = response?.res?.data?.data?.file_url;
  //     newDocs[index].category = categoryStatic[0].id;
  //     newDocs[index].fileTypeName = fileTypeName;
  //     setDocs(newDocs);
  //     // showToast('success', message);
  //     toast.success(response?.res?.data?.message, {
  //       autoClose: 2000,
  //       position: "bottom-right",
  //     });
  //   } else {
  //     // console.log('282',response?.res?.data?.message);

  //     // console.log(response?.res?.data?.message);
  //     setErrorDoc(response?.res?.data?.message);
  //     // alert(response?.res?.data?.message);
  //     toast.error(response?.res?.data?.message, {
  //       autoClose: 2000,
  //       position: "bottom-right",
  //     });
  //   }
  //   setIsDocsLoading(false);
  // }
  const handleUploadForAssesmentDocs = async (index) => {
    const newDocs = [...doctorAssesment];
    setIsDocsLoading(true);

    for (let i = 0; i < newDocs.length; i++) {
      if (newDocs[i].status !== "uploaded" && newDocs[i].doc) {
        const response = await handleUploadDocFile(newDocs[i].doc);
        const message = errorMessageCreate(response?.res?.data?.message);

        if (response?.res?.data?.statusCode === 200) {
          const fileType = newDocs[i].doc.type;
          let fileTypeName = "Document";
          if (fileType.startsWith("image/")) fileTypeName = "Image";

          newDocs[i].status = "uploaded";
          newDocs[i].doc = response?.res?.data?.data?.file_url;
          newDocs[i].category = categoryStatic[0].id;
          newDocs[i].fileTypeName = fileTypeName;

          toast.success(response?.res?.data?.message, {
            autoClose: 2000,
            position: "bottom-right",
          });
        } else {
          setErrorDoc(response?.res?.data?.message);
          toast.error(response?.res?.data?.message, {
            autoClose: 2000,
            position: "bottom-right",
          });
        }
      }
    }

    setDoctorAssesment(newDocs);
    setIsDocsLoading(false);
  };


  const handleDeleteForDocs = (index) => {
    if (docs.length === 1) {
      setDocs([
        { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
      ]);
    } else {
      setDocs((prevDocs) => prevDocs.filter((_, i) => i !== index));
    }
  };

  const handleDeleteAssesmetsDocs = (index) => {
    if (doctorAssesment.length === 1) {
      setDoctorAssesment([
        { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
      ]);
    } else {
      setDoctorAssesment((prevDocs) => prevDocs.filter((_, i) => i !== index));
    }
  }
  const handleUploadDocFile = async (file) => {
    try {
      const formdata = new FormData();
      formdata.append("file", file);

      const body = formdata;

      return await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_DOC, body);
    } catch (err) { }
  };
  const addMoreFileForDocs = () => {
    setErrorDoc();
    setDocs([
      ...docs,
      { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
    ]);
  };

  const addMoreFileForAssesments = async () => {
    if (doctorAssesment.length > 10) {
      return;
    }
    setDoctorAssesment([
      ...doctorAssesment,
      { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
    ]);
  }

  const handleSubmit = async () => {
    console.log(doctorAssesment);
    try {
      let formData = {};


      let newErrors = {};
      var validations_array = { ...initialValues };

      let isValid = true;
      Object.keys(validations_array).forEach((key) => {
        // console.log("307");
        let getPreviousValue = uploadedRecordSeesion?.find((item) => {
          return item.session_type == key && (item?.transcription_text && item?.transcription_text != '')
        });
        // console.log('getPreviousValue',getPreviousValue);

        if (getPreviousValue == undefined && !initialValues[key] && key != "assessment") {
          isValid = false;
          newErrors[key] = "This field is required.";
        }
      });

      setErrors(newErrors);
      sethasClickedSubmit(true);
      /*assesment_list?.map((item, index) => {
        if (
          uploadedFiles[item.id] == "" ||
          uploadedFiles[item.id] == undefined ||
          uploadedFiles[item.id] == null
        ) {
          isValid = false;
        }
      });
      if (assesment_list?.length == 0) {
        isValid = false;
        // showToast("error", "Please add at least one assessment.");
        toast.error("Please add at least one assessment.", {
          autoClose: 2000,
          position: "bottom-right",
        });
        return;
      }*/
      toast.dismiss();
      if (!isValid) {
        console.log("initialValues", initialValues);
        let validation_message = '';
        if ((initialValues.formulation == '' || initialValues.clinical_interview == '') && (tab_value == 0 || initialValues.mse != '')) {
          setTabValue(0);
          validation_message = 'Pleasce upload all required report background section tab.';
        }
        //  else if (initialValues.assessment=='') {
        //   setTabValue(1);
        //   validation_message = 'Pleasce upload all required report background section tab.';
        // }
        else {
          setTabValue(2);

          validation_message = 'Pleasce upload all required report mse tab.';
        }
        toast.error(validation_message, {
          autoClose: 2000,
          position: "top-right",
        });
        return;
      }


      if (isValid) {
        let assessmentsFiles = [];
        /*assesment_list?.map((item, index) => {
          if (uploadedFiles[item.id]) {
            assessmentsFiles.push({
              assessment_id: item.id,
              report_url: uploadedFiles[item.id],
            });
          }
        });*/
        doctorAssesment?.filter(item => item?.doc).map((item, index) => {
          console.log("uploadedFiles[item.id]", item);
          if (item?.doc != '') {
            assessmentsFiles.push({
              assessment_id: "",
              report_url: item?.doc,
            });
          }
        })
        // return;
        let filesArray = [];
        // docs?.map((item, index) => {
        //   if (item?.status == "uploaded") {
        //     filesArray.push({
        //       type: "doc",
        //       file: item?.doc,
        //       report_type_id: item?.category,
        //     });
        //   }
        // });
        if (filesArray?.length > 0) initialValues.files = filesArray;

        let formData = {};
        if (assessmentsFiles?.length > 0) {
          initialValues.assessments = assessmentsFiles;
          formData.assessments = assessmentsFiles;
        }
        delete initialValues.assessment;
        // if (isConfirmed) {
        //   if (imageSrc) {
        //     initialValues.dr_uploaded_face_image = facialImageFile;
        //   }
        // }
        setIsSubmit(true);


        if (initialValues?.clinical_interview) {
          formData.clinical_interview = initialValues?.clinical_interview;
        }
        if (initialValues?.formulation) {
          formData.formulation = initialValues?.formulation;
        }

        if (initialValues?.mse) {
          formData.mse = initialValues?.mse;
        }

        const response = await CallWithAuth(
          "POST",
          UPLOAD_PATIENT_REPORT_RECORD_SESSION_SAVE + `/${props.patientid}`,
          formData
        );
        // console.log('response',response?.res?.data);
        if (response?.res?.status == 201) {
          props.onHide();
          // toast.success(response?.res?.data?.message, {
          //   autoClose: 2000,
          //   position: "bottom-right",
          // });
          // showToast("success", response?.res?.data?.message);
          setDocs([{ doc: null, status: "not_uploaded", category: "" }]);
          setDocs([{ doc: null, status: "not_uploaded", category: "" }]);
          setInitialValues((prevState) => ({
            ...prevState,
            clinical_interview: "",
            assessment: "",
            formulation: "",
            mse: "",
          }));
          setErrors((prevState) => ({
            ...prevState,
            clinical_interview: "",
            assessment: "",
            formulation: "",
            mse: "",
          }));
          setAssessmentAudio(null);
          setFormulationAudio(null);
          setAudio(null);
          setDoctorAssesment([{ doc: null, status: "not_uploaded", category: "" }]);
          onsuccess();
        } else if (response?.res?.status == 403) {
          props.onHide();
          // props.onSuccess();
          // onsuccess();
          setDocs([{ doc: null, status: "not_uploaded", category: "" }]);
          setInitialValues((prevState) => ({
            ...prevState,
            clinical_interview: "",
            assessment: "",
            formulation: "",
            mse: "",
          }));
          // setInitialValues({
          //   clinical_interview:'',
          //   assessment:'',
          //   formulation:''
          // });
          // setErrors({});
          setErrors((prevState) => ({
            ...prevState,
            clinical_interview: "",
            assessment: "",
            formulation: "",
            mse: "",
          }));
          setAssessmentAudio(null);
          setFormulationAudio(null);
          setAudio(null);
          setAudioMse(null);

          toast.error(response?.res?.data?.message, {
            autoClose: 2000,
            position: "top-right",
          });
        } else {
          toast.error(errorMessageCreate(response?.res?.data?.message), {
            autoClose: 2000,
            position: "top-right",
          });
        }
      }
      setIsSubmit(false);
    } catch (err) {
      setIsSubmit(false);
      console.log(err);
    }
  };

  // Check if all files are uploaded
  const allFilesUploadedForDocs = docs?.every(
    (fileObj) => fileObj.status === "uploaded"
  );

  const allFilesUploadedForAssessment = doctorAssesment?.every(
    (fileObj) => fileObj.status === "uploaded"
  );

  const handleDocsChange = (e, index) => {
    const newDocs = [...docs];
    newDocs[index].doc = e.target.files[0];
    newDocs[index].status = "not_uploaded";
    setDocs(newDocs);
  };

  // const handleChangeDefaultAssesment = (e,index) => {
  //   const doctorAssesmentDoc = [...doctorAssesment];
  //   // console.log("===========>", e.target.files)
  //   doctorAssesmentDoc[index].doc = e.target.files[0];
  //   doctorAssesmentDoc[index].status = "not_uploaded";
  //   setDoctorAssesment(doctorAssesmentDoc);
  // };
  // const handleChangeDefaultAssesment = (e, index) => {
  //   const file = e.target.files[0];
  //   const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

  //   if (file && allowedTypes.includes(file.type)) {
  //     const doctorAssesmentDoc = [...doctorAssesment];
  //     doctorAssesmentDoc[index].doc = file;
  //     doctorAssesmentDoc[index].status = "not_uploaded";
  //     doctorAssesmentDoc[index].system_file_name = e.target.files[0].name;
  //     setDoctorAssesment(doctorAssesmentDoc);
  //   } else {
  //     showToast('Only .doc, .docx, and .pdf files are allowed');
  //     e.target.value = null; // Optional: reset the input
  //   }
  // };

  const handleChangeDefaultAssesment = (e, index) => {
    const files = Array.from(e.target.files); // FileList কে array তে convert করল
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];

    const newFiles = files.filter(file => allowedTypes.includes(file.type));
    if (newFiles.length === 0) {
      showToast('Only .doc, .docx, and .pdf files are allowed');
      e.target.value = null;
      return;
    }

    const updatedDoctorAssesment = [...doctorAssesment];

    newFiles.forEach(file => {
      updatedDoctorAssesment.push({
        doc: file,
        status: 'not_uploaded',
        system_file_name: file.name,
      });
    });

    setDoctorAssesment(updatedDoctorAssesment);
  };


  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const handleDrop = (e, index) => {
    e.preventDefault(); // Prevent default browser behavior
    e.stopPropagation();

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const newDocs = [...docs];
      newDocs[index] = {
        ...newDocs[index],
        doc: files[0], // Assign the first dropped file
        status: "not_uploaded", // Update the status
      };
      setDocs(newDocs); // Update state with the new file
    }
  };

  const handleDropAssesmentFile = (e, index) => {
    e.preventDefault(); // Prevent default browser behavior
    e.stopPropagation();

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      if (!allowedTypes.includes(files[0]?.type)) {
        return;
      }
      const newDocs = [...doctorAssesment];
      newDocs[index] = {
        ...newDocs[index],
        doc: files[0], // Assign the first dropped file
        status: "not_uploaded", // Update the status
      };
      setDoctorAssesment(newDocs); // Update state with the new file
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault(); // Required to enable onDrop
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    console.log("Drag left container");
  };
  const handleConfirmationChange = (value) => {
    setIsConfirmed(value);
  };

  const capture = async (e) => {
    e.preventDefault();

    const image = webcamRef.current?.getScreenshot();
    if (image) {
      // base64ToFile();
      let fileName = "face_image.jpeg";
      let face_image = await base64ToFile(image, fileName, "image/jpeg");
      setImageSrc(image);
      // setFacialImageFile(face_image);
      const response = await handleUploadDocFile(face_image);
      if (response?.res?.data?.statusCode === 200) {
        // console.log("response==>", response.res.data.data.file_url);
        setFacialImageFile(response.res.data.data.file_url);
        setImageSrc(image);
      } else {
        showToast("error", response.res.data.message);
      }
    }
  };

  const handledeleteFile = async (e, id) => {
    // e.preventDefault();
    // const response = await CallWithAuth(
    //   "DELETE",
    //   UPLOAD_PATIENT_REPORT_RECORD_SESSION_SAVE + `/${id}`,
    //   initialValues
    // );
    const result = await MySwal.fire({
      title: "Are you sure want delete document?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
        popup: "my-custom-popup-class", // Custom class for the modal
      },
    });

    if (result.isConfirmed) {
      // Send email with the selected data
      try {
        const response = await CallWithAuth(
          "DELETE",
          DELETE_DOCUMENT + `${id}`
        );
        if (response?.res?.data?.statusCode === 200) {
          setUploadedReport((pre) => pre.filter((item) => item.id !== id));
          showToast("success", response.res.data.message);
        } else {
          showToast("error", response.res.data.message);
        }
      } catch (error) {
        console.error("Error sending email:", error);
      }
    }
  };

  const handleFileChangeAssesment = async (e, assessmentId) => {
    const { files } = e.target;
    const file = files[0];

    if (file) {
      const validExtensions = [".pdf", ".doc", ".docx"];
      const fileName = file.name.toLowerCase();
      const isValid = validExtensions.some((ext) => {
        return fileName.endsWith(ext);
      });

      if (!isValid) {
        toast.warn("Only PDF, DOC, and DOCX formats are supported.", {
          autoClose: 2000,
          position: "bottom-right",
        });
        return;
      }
    }

    setUploadedassessmentFilesStatus((prevFiles) => ({
      ...prevFiles,
      [assessmentId]: true,
    }));
    // Call the API to upload the file
    const response = await handleUploadDocFile(file);
    // console.log("response==>", response?.res?.data?.data?.file_url);

    // Check if the API call was successful
    if (response?.res?.data?.statusCode === 200) {
      setUploadedFiles((prevFiles) => ({
        ...prevFiles,
        [assessmentId]: response?.res?.data?.data?.file_url,
      }));
    } else {
      setAudio(null);
      setErrors((prev) => ({
        ...prev,
        clinical_interview: response?.res?.data?.message,
      }));

      toast.error(response?.res?.data?.message, {
        autoClose: 2000,
        position: "bottom-right",
      });
    }
    // const file = e.target.files?.[0] || null;
    // setUploadedFiles((prevFiles) => ({
    //   ...prevFiles,
    //   [assessmentId]: file,
    // }));
    setUploadedassessmentFilesStatus((prevFiles) => ({
      ...prevFiles,
      [assessmentId]: false,
    }));
  };


  const handleDropAssesmentFromNew = async (e, assessmentId) => {
    e.preventDefault();
    const files = e.dataTransfer.files[0];
    console.log("files===>", files);

    if (files) {
      const validExtensions = [".pdf", ".doc", ".docx"];
      const fileName = files.name.toLowerCase();

      const isValid = validExtensions.some((ext) => fileName.endsWith(ext));

      if (!isValid) {
        toast.warn("Only PDF, DOC, and DOCX formats are supported.", {
          autoClose: 2000,
          position: "bottom-right",
        });
        return;
      }
    }

    setUploadedassessmentFilesStatus((prevFiles) => ({
      ...prevFiles,
      [assessmentId]: true,
    }));
    // Call the API to upload the file
    const response = await handleUploadDocFile(files);
    // console.log("response==>", response?.res?.data?.data?.file_url);

    // Check if the API call was successful
    if (response?.res?.data?.statusCode === 200) {
      setUploadedFiles((prevFiles) => ({
        ...prevFiles,
        [assessmentId]: response?.res?.data?.data?.file_url,
      }));
    } else {
      // Display an error toast if there was an error during the API call
      // console.log( response?.res?.data?.message);

      setAudio(null);
      setErrors((prev) => ({
        ...prev,
        clinical_interview: response?.res?.data?.message,
      }));

      toast.error(response?.res?.data?.message, {
        autoClose: 2000,
        position: "bottom-right",
      });
    }
    // setDraggingAssesmentFromFrom(false);

    // // Get the dropped files
    // const files = e.dataTransfer.files;
    // if (files.length > 0) {
    //   // Simulate onChange for the input file

    //   handleFileChangeAssesment(e,id);
    // }
    setUploadedassessmentFilesStatus((prevFiles) => ({
      ...prevFiles,
      [assessmentId]: false,
    }));
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {isLoadingModalData && (
          // <><h1 className="text-center">Report loading...</h1></>
          <>
            <div className="full-page-loader">
              <div className="loader"></div>
            </div>
          </>
        )}
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Upload Files XXXXXXXXXXS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <section className="patient_form_block">
            <div className="site_container report-upload-block-main upload-block-files-report">
              <div className="patient_form row d-flex gap-0">
                <Tabs
                  value={tab_value}
                  onChange={handleChange}
                  variant="fullWidth"
                  className="mb-3"
                >
                  <Tab label="Background Section" />

                  <Tab label="Assessment" />
                  <Tab label="MSE" />
                </Tabs>

                {tab_value == 0 && (
                  <>
                    <div className="field_block col-md-6">
                      <div className="upload_field">
                        <div className="title">
                          <label>Upload files for clinical interview</label>{" "}
                          <a
                            data-tooltip-id="my-tooltip-2"
                            href="#"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img src={tooltip_info_icon} alt="Info" />{" "}
                          </a>
                          <ReactTooltip
                            id="my-tooltip-2"
                            place="bottom"
                            variant="info"
                            className="custom-tooltip"
                            content="Please upload audio file or text transcription of face-to-face assessment with patient. "
                          />
                        </div>

                        <div
                          className="upload_ui"
                          onDrop={(e) => handleDropClinicalIntakeFrom(e)}
                          onDragOver={handleDragOverClinicalIntakeFrom}
                          onDragLeave={handleDragLeaveClinicalIntakeFrom}
                        >
                          <input
                            type="file"
                            name="audio"
                            accept=".mp3, .wav, .m4a , .pdf" // Restrict file types
                            // onChange={handleFileChange}
                            onChange={(event) =>
                              handleFileChange(event, "clinical_interview")
                            }
                            style={{ display: "none" }} // Hide input element
                            id={`clinical-interview-file`}
                          />
                          <label className="upload_ui_label">
                            <div className="ui_inner">
                              <img
                                className="cursor_pointer_custom_cls"
                                onClick={() =>
                                  document
                                    .getElementById(`clinical-interview-file`)
                                    .click()
                                }
                                src={upload_icon}
                                alt="Upload"
                              />
                              {/* <h5>{isuploadclinicalinterView? "Uploading" : "Upload"}</h5> */}
                              <h5
                                className="cursor_pointer_custom_cls"
                                onClick={() =>
                                  document
                                    .getElementById(`clinical-interview-file`)
                                    .click()
                                }
                              >
                                {isuploadclinicalinterView
                                  ? "Uploading"
                                  : "Upload"}{" "}
                                {isuploadclinicalinterView && (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                              </h5>
                              <p>
                                <span>Browse</span> to upload the file
                              </p>
                            </div>
                          </label>
                        </div>

                        {uploadedRecordSession?.clinical_interview && (
                          <>
                            <div className="record_seesion_info">
                              <p className="sm_txt">
                                <strong>
                                  {createShortNameFile(
                                    uploadedRecordSession?.clinical_interview
                                  )}
                                </strong>
                              </p>
                              <a
                                href={`${uploadedRecordSession.clinical_interview}`} // Full URL for S3 file
                                target="_blank" // Opens link in a new tab
                                rel="noopener noreferrer" // Security best practice
                                className="edit"
                              >
                                <i className="fa-solid fa-eye"></i>
                              </a>
                            </div>
                          </>
                        )}
                        {audio ? (
                          <>
                            <p className="sm_txt">
                              <strong>{audio.name}</strong>
                            </p>
                          </>
                        ) : (
                          <p className="sm_txt">
                            Supported file formats are{" "}
                            <strong>MP3, WAV, M4A, PDF.</strong>
                          </p>
                        )}
                        {uploadedRecordSeesion?.find(
                          (item) =>
                            item.session_type === 'clinical_interview' &&
                            item.transcription_text &&
                            item.transcription_text !== ''
                        ) && (
                            <p className="sm_txt mt-2 mb-2 text-success">
                              A clinical interview has already been uploaded.
                              {/* Uploading a new file will replace the existing one. */}
                            </p>
                          )}

                        {getErros?.clinical_interview && (
                          <div className="errors-from">
                            {getErros?.clinical_interview}
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="field_block col-md-6"
                      onDrop={(e) => handleDropFormulationFrom(e)}
                      onDragOver={handleDragOverFormulationFrom}
                      onDragLeave={handleDragLeaveFormulationFrom}
                    >
                      <div className="upload_field">
                        <div className="title">
                          <label>Upload files for formulation audio</label>{" "}
                          <a
                            data-tooltip-id="my-tooltip-3"
                            href="#"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img src={tooltip_info_icon} alt="Info" />{" "}
                          </a>
                          <ReactTooltip
                            id="my-tooltip-3"
                            place="bottom"
                            variant="info"
                            className="custom-tooltip"
                            content="Please upload audio file or text transcription of your own individual clinical impressions and thoughts to assist with the formulation and diagnosis generation."
                          />
                        </div>

                        <div className="upload_ui">
                          <input
                            type="file"
                            name="audio"
                            accept=".mp3, .wav, .m4a , .pdf" // Restrict file types
                            onChange={handleChangeFormulationFile}
                            style={{ display: "none" }} // Hide input element
                            id={`formulation-audio-file`}
                          />
                          <label className="upload_ui_label">
                            <div className="ui_inner">
                              <img
                                className="cursor_pointer_custom_cls"
                                onClick={() =>
                                  document
                                    .getElementById(`formulation-audio-file`)
                                    .click()
                                }
                                src={upload_icon}
                                alt="Upload"
                              />
                              {/* <h5>Upload</h5> */}
                              <h5
                                className="cursor_pointer_custom_cls"
                                onClick={() =>
                                  document
                                    .getElementById(`formulation-audio-file`)
                                    .click()
                                }
                              >
                                {isuploadformulation ? "Uploading" : "Upload"}{" "}
                                {isuploadformulation && (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                              </h5>
                              <p>
                                <span>Browse</span> to upload the file
                              </p>
                            </div>
                          </label>
                        </div>
                        {uploadedRecordSession?.formulation && (
                          <>
                            <div className="record_seesion_info">
                              <p className="sm_txt">
                                <strong>
                                  {createShortNameFile(
                                    uploadedRecordSession?.formulation
                                  )}
                                </strong>
                              </p>
                              <a
                                href={`${uploadedRecordSession.formulation}`} // Full URL for S3 file
                                target="_blank" // Opens link in a new tab
                                rel="noopener noreferrer" // Security best practice
                                className="edit"
                              >
                                <i className="fa-solid fa-eye"></i>
                              </a>
                            </div>
                          </>
                        )}
                        {formulationaudio ? (
                          <p className="sm_txt">
                            <strong>{formulationaudio.name}</strong>
                          </p>
                        ) : (
                          <p className="sm_txt">
                            Supported file formats are{" "}
                            <strong>MP3, WAV, M4A , PDF .</strong>
                          </p>
                        )}
                        {uploadedRecordSeesion?.find(
                          (item) =>
                            item.session_type === 'formulation' &&
                            item.transcription_text &&
                            item.transcription_text !== ''
                        ) && (
                            <p className="sm_txt mt-2 mb-2 text-success">
                              A Formulation interview has already been uploaded.
                              {/* Uploading a new file will replace the existing one. */}
                            </p>
                          )}
                        {getErros?.formulation && (
                          <div className="errors-from">
                            {getErros?.formulation}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* <div
                  className="col-md-6 field_block"
                  onDrop={(e) => handleDropAssesmentFrom(e)}
                  onDragOver={handleDragOverAssesmentFrom}
                  onDragLeave={handleDragLeaveAssesmentFrom}
                >
                  <div className="upload_field">
                    <div className="title">
                      <label>Upload the assessment audio</label>{" "}
                      <a
                        href="#"
                        data-bs-toggle="tooltip"
                        data-bs-title="Allow our advanced AI models to learn how you like your reports to be written in your preferred tone and format."
                        onClick={(e) => e.preventDefault()}
                      >
                        <img src={tooltip_info_icon} alt="Info" />{" "}
                      </a>
                    </div>

                    <div className="upload_ui">
                      <label className="upload_ui_label">
                        <input
                          type="file"
                          name="audio"
                          accept=".mp3, .wav, .m4a" // Restrict file types
                          onChange={handleAssesmentFileChange}
                          style={{ display: "none" }} // Hide input element
                        />
                        <div className="ui_inner">
                          <img src={upload_icon} alt="Upload" />
                          <h5>Upload</h5>
                          <p>
                            <span>Browse</span> to upload the file
                          </p>
                        </div>
                      </label>
                    </div>
                    {uploadedRecordSession?.assessment && (
                      <>
                        <div className="record_seesion_info">
                          <p className="sm_txt">
                            <strong>
                              {createShortNameFile(
                                uploadedRecordSession?.assessment
                              )}
                            </strong>
                          </p>
                          <a
                            href={`${uploadedRecordSession.assessment}`} // Full URL for S3 file
                            target="_blank" // Opens link in a new tab
                            rel="noopener noreferrer" // Security best practice
                            className="edit"
                          >
                            <i className="fa-solid fa-eye"></i>
                          </a>
                        </div>
                      </>
                    )}
                    {assessmentaudio ? (
                      <p className="sm_txt">
                        <strong>{assessmentaudio.name}</strong>
                      </p>
                    ) : (
                      <p className="sm_txt">
                        Supported file formats are{" "}
                        <strong>MP3, WAV, M4A.</strong>
                      </p>
                    )}
                    {getErros?.assessment && (
                      <div className="errors-from">{getErros?.assessment}</div>
                    )}
                  </div>
                </div> */}

                {tab_value == 1 && (
                  <>
                    <div className="row">
                      {/*{assesment_list?.length > 0 ? (
                        <>
                          {assesment_list?.map((assessment) => (
                            <div
                              key={assessment.id}
                              className="col-md-6 field_block"
                            >
                              <div className="upload_field">
                                <div className="title">
                                  <label>Upload the assessment doc file</label>
                                  <a
                                    href="#"
                                    data-bs-toggle="tooltip"
                                    data-bs-title="Allow our advanced AI models to learn how you like your reports to be written in your preferred tone and format."
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <img src={tooltip_info_icon} alt="Info" />
                                  </a>
                                </div>

                                <div
                                  className={`assessment_item ${
                                    dragging[assessment.id] ? "dragging" : ""
                                  }`}
                                  onDragOver={(e) =>
                                    handleDragOver(e, assessment.id)
                                  }
                                  onDragLeave={() => handleDragLeave(assessment.id)}
                                  onDrop={(e) =>
                                    handleDropAssesmentFromNew(e, assessment.id)
                                  }
                                >
                                  <div className="d-flex">
                                    <p className="sm_txt">
                                      <strong>
                                        {
                                          new URL(assessment.assessment_link)
                                            .hostname
                                        }
                                      </strong>
                                    </p>
                                    <a
                                      href={assessment.assessment_link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="edit"
                                    >
                                      <i className="fa-solid fa-eye"></i>
                                    </a>
                                  </div>

                                  <div className="upload_ui">
                                    <input
                                      type="file"
                                      accept=" .pdf, .doc, .docx"
                                      onChange={(e) =>
                                        handleFileChangeAssesment(e, assessment.id)
                                      }
                                      style={{ display: "none" }}
                                      id={`assessment-audio-file-${assessment.id}`}
                                    />
                                    <label className="upload_ui_label">
                                      <div className="ui_inner">
                                        <img
                                          className="cursor_pointer_custom_cls"
                                          onClick={() =>
                                            document
                                              .getElementById(
                                                `assessment-audio-file-${assessment.id}`
                                              )
                                              .click()
                                          }
                                          src={upload_icon}
                                          alt="Upload"
                                        />
                                        <h5
                                          className="cursor_pointer_custom_cls"
                                          onClick={() =>
                                            document
                                              .getElementById(
                                                `assessment-audio-file-${assessment.id}`
                                              )
                                              .click()
                                          }
                                        >
                                          {uploadedassessmentFilesStatus?.[
                                            assessment.id
                                          ]
                                            ? "Uploading"
                                            : "Upload"}{" "}
                                          {uploadedassessmentFilesStatus?.[
                                            assessment.id
                                          ] && (
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          )}
                                        </h5>
                                        <p>
                                          <span>Browse</span> to upload the file
                                        </p>
                                      </div>
                                    </label>
                                  </div>

                                  {uploadedFiles[assessment.id] ? (
                                    <p className="sm_txt">
                                      <strong>
                                        {createShortNameFile(
                                          uploadedFiles[assessment.id]
                                        )}
                                      </strong>
                                    </p>
                                  ) : (
                                    <p className="sm_txt">
                                      Supported formats:{" "}
                                      <strong>.pdf, .doc, .docx</strong> (Max size:{" "}
                                      <strong>5 MB</strong>)
                                    </p>
                                  )}

                                  {(uploadedFiles[assessment.id] == "" ||
                                    uploadedFiles[assessment.id] == null ||
                                    uploadedFiles[assessment.id] == undefined) &&
                                    hasClickedSubmit && (
                                      <div className="errors-from">
                                        The fields is required
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          ))}
                          {assesment_list?.length == 0 && (
                            <p className="text-center"><strong>No assesment found </strong></p> 
                          )}
                        </>
                      ):*/}
                      {/* ( */}
                      <>
                        <div className="col-md-12 field_block">
                          <div className="upload_field">
                            <div className="title">
                              <label>Upload the assessment doc file</label>{" "}
                              <a
                                data-tooltip-id="my-tooltip-4"
                                data-bs-toggle="tooltip"
                                data-bs-title="Allow our advanced AI models to learn how you like your reports to be written in your preferred tone and format."
                                onClick={(e) => e.preventDefault()}
                              >
                                <img src={tooltip_info_icon} alt="Info" />{" "}
                              </a>
                              <ReactTooltip
                                id="my-tooltip-4"
                                place="bottom"
                                variant="info"
                                className="custom-tooltip"
                                content="Please upload standardised assessment reports i.e. vineland, PAI, SRS-2 to be transcribed and interpreted into your report."
                              />
                            </div>

                            <div className="jjhj">
                              <div className="pr-4 customclass">
                                {/* Upload section for the first file */}
                                <div className="form-group ff">
                                  <div
                                    className="upload-container"
                                    onDrop={(e) => handleDropAssesmentFile(e, 0)}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                  >
                                    <input
                                      type="file"
                                      className="ddddd"
                                      id={`doc-input-assesment-deafult-0`}
                                      name={`doc-old-0`}
                                      accept=".doc, .docx, .pdf"
                                      onChange={(e) => handleChangeDefaultAssesment(e, 0)}
                                      multiple
                                      style={{ display: "none" }}
                                    />
                                    <label className="file-label">
                                      <img
                                        className="cursor_pointer_custom_cls"
                                        onClick={() =>
                                          document.getElementById(`doc-input-assesment-deafult-0`).click()
                                        }
                                        src={upload_icon}
                                        alt="Upload"
                                      />
                                      <h5
                                        className="cursor_pointer_custom_cls"
                                        onClick={() =>
                                          document.getElementById(`doc-input-assesment-deafult-0`).click()
                                        }
                                      >
                                        Upload
                                      </h5>
                                      {!doctorAssesment[0]?.doc && (
                                        <>
                                          <br />
                                          <p id="file-name" className="browse-file">
                                            <span>Browse to upload the file</span> <br />
                                            <span>Supported file types: pdf, .doc, .docx</span>
                                            <br />
                                            <span>You can upload files with a maximum size of 5MB.</span>
                                          </p>
                                        </>
                                      )}
                                    </label>
                                  </div>

                                  <div className="otherbuttons d-flex">
                                    <div className="d-flex">
                                      <button
                                        type="button"
                                        onClick={() =>
                                          doctorAssesment[0].status !== "uploaded" &&
                                          handleUploadForAssesmentDocs(0)
                                        }
                                        disabled={isDocsLoading && doctorAssesment[0].status !== "uploaded"}
                                        className="upload-button form-control"
                                      >
                                        {isDocsLoading && doctorAssesment[0].status !== "uploaded" ? (
                                          <>
                                            Upload
                                            <span className="button-loader-cls"></span>
                                          </>
                                        ) : doctorAssesment[0].status === "uploaded" ? (
                                          "Uploaded"
                                        ) : (
                                          "Upload"
                                        )}
                                      </button>

                                      {doctorAssesment[0].status === "uploaded" && (
                                        <button
                                          type="button"
                                          onClick={() => handleDeleteAssesmetsDocs(0)}
                                          className="delete-button form-control"
                                          style={{ marginLeft: "10px" }}
                                        >
                                          Remove
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* List of all uploaded files */}
                                {doctorAssesment.filter(file => file.status === "uploaded").length > 0 && (
                                  <div className="uploaded-files-list mt-3">
                                    <h6>Uploaded Files:</h6>
                                    {doctorAssesment
                                      .filter(file => file.status === "uploaded")
                                      .map((file, index) => (
                                        <div key={index} className="uploaded-file-info mb-2 d-flex align-items-center justify-content-between">
                                          <div>
                                            <i className="fa-solid fa-file-alt" style={{ marginRight: "8px" }}></i>
                                            {createShortNameFileDoc(file.system_file_name)}
                                            <span className="file-type">({getFileType(file.doc)})</span>
                                          </div>
                                          <div className="d-flex">
                                            <button
                                              type="button"
                                              onClick={() => handleDeleteAssesmetsDocs(index)}
                                              className="delete-button form-control"
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                      </>
                      {/* )} */}

                    </div>
                  </>
                )}

                {tab_value == 2 && (
                  <>
                    {/* <div className="col-md-12 field_block">
                      <div className="upload_field">
                        <div className="title">
                          <label>Upload the reports pdfs/images</label>{" "}
                          <a
                            href="#"
                            data-bs-toggle="tooltip"
                            data-bs-title="Allow our advanced AI models to learn how you like your reports to be written in your preferred tone and format."
                            onClick={(e) => e.preventDefault()}
                          >
                            <img src={tooltip_info_icon} alt="Info" />{" "}
                          </a>
                        </div>

                        <div className="jjhj">
                          <div className="pr-4 customclass">
                            {docs.map((fileObj, index) => (
                              <div key={index}>
                                <div className="form-group ff">
                                  {fileObj.status === "uploaded" ? (
                                    <span>
                                      <div className="uploaded-file-info">
                                        <p>
                                          <i
                                            className="fa-solid fa-file-alt"
                                            style={{ marginRight: "8px" }}
                                          ></i>
                                          Document File uploaded
                                        </p>
                                        <p>
                                          <span className="file-name">
                                            {createShortNameFileDoc(
                                              fileObj.doc
                                            )}
                                          </span>
                                          <span className="file-type">
                                            ({getFileType(fileObj.doc)})
                                          </span>
                                        </p>
                                      </div>
                                    </span>
                                  ) : (
                                    <div
                                      className="upload-container"
                                      onDrop={(e) => handleDrop(e, index)}
                                      onDragOver={handleDragOver}
                                      onDragLeave={handleDragLeave}
                                    >
                                      <input
                                        type="file"
                                        className="ddddd"
                                        id={`doc-input-old-${index}`}
                                        name={`doc-old-${index}`}
                                        accept=".doc, .docx, .pdf, .png, .jpg, .jpeg"
                                        onChange={(e) =>
                                          handleDocsChange(e, index)
                                        }
                                        style={{ display: "none" }} // Hide input element
                                      />
                                      <label
                                        // htmlFor={`doc-input-old-${index}`}
                                        className="file-label"
                                      >
                                        <img
                                          className="cursor_pointer_custom_cls"
                                          onClick={() =>
                                            document
                                              .getElementById(
                                                `doc-input-old-${index}`
                                              )
                                              .click()
                                          }
                                          src={upload_icon}
                                          alt="Upload"
                                        />

                                        <h5
                                          className="cursor_pointer_custom_cls"
                                          onClick={() =>
                                            document
                                              .getElementById(
                                                `doc-input-old-${index}`
                                              )
                                              .click()
                                          }
                                        >
                                          Upload
                                        </h5>
                                        {fileObj.doc ? (
                                          <p
                                            id="file-name"
                                            className="browse-file"
                                          >
                                            Document Selected. Please select a
                                            category and upload.
                                          </p>
                                        ) : (
                                          <>
                                            <br />
                                            <p
                                              id="file-name"
                                              className="browse-file"
                                            >
                                              <span>
                                                Browse to upload the file
                                              </span>{" "}
                                              <br />
                                              <span>
                                                Supported file types: .doc,
                                                .docx, .pdf, .png, .jpg, .jpeg
                                              </span>
                                              <br />
                                              <span>
                                                You can upload files with a
                                                maximum size of 5MB.{" "}
                                              </span>
                                            </p>
                                          </>
                                        )}
                                      </label>
                                      
                                    </div>
                                  )}

                                  <div className="otherbuttons d-flex">
                                   

                                    <div className="d-flex">
                                      <button
                                        type="button"
                                        // onClick={() => handleUploadForDocs(index)}
                                        onClick={() =>
                                          fileObj.status !== "uploaded" &&
                                          handleUploadForDocs(index)
                                        }
                                        disabled={
                                          isDocsLoading &&
                                          fileObj.status !== "uploaded"
                                            ? isDocsLoading
                                            : false
                                        }
                                        className="upload-button form-control"
                                      >
                                        {isDocsLoading &&
                                        fileObj.status !== "uploaded" ? (
                                          <>
                                            Upload
                                            <span className="button-loader-cls"></span>
                                          </>
                                        ) : fileObj.status === "uploaded" ? (
                                          "Uploaded"
                                        ) : (
                                          "Upload"
                                        )}
                                      </button>
                                      {fileObj.status === "uploaded" && (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleDeleteForDocs(index)
                                          }
                                          className="delete-button form-control"
                                          style={{ marginLeft: "10px" }}
                                        >
                                          Remove
                                        </button>
                                      )}
                                    </div>
                                    {allFilesUploadedForDocs &&
                                      index === docs.length - 1 && (
                                        <button
                                          type="button"
                                          onClick={addMoreFileForDocs}
                                          className="add-more-button form-control"
                                        >
                                          Add More Files
                                        </button>
                                      )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                      </div>
                    </div> */}

                    <div className="field_block col-md-6">
                      <div className="upload_field">
                        <div className="title">
                          <label>Upload files for MSE interview</label>{" "}
                          <a
                            data-tooltip-id="my-tooltip-5"
                            href="#"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img src={tooltip_info_icon} alt="Info" />{" "}
                          </a>
                          <ReactTooltip
                            id="my-tooltip-5"
                            place="bottom"
                            variant="info"
                            className="custom-tooltip"
                            content="Please upload your audio file or text transcription of your mental status examination of the patient to be interpreted into your report."
                          />
                        </div>

                        <div
                          className="upload_ui"
                          onDrop={(e) => handleDropMseFrom(e)}
                          onDragOver={handleDragOverMseFrom}
                          onDragLeave={handleDragLeaveMseFrom}
                        >
                          <input
                            type="file"
                            name="audio"
                            accept=".mp3, .wav, .m4a ,.pdf" // Restrict file types
                            // onChange={handleFileChange}
                            onChange={(event) =>
                              handleFileChangeMse(event, "mse")
                            }
                            style={{ display: "none" }} // Hide input element
                            id={`mse-file`}
                          />
                          <label className="upload_ui_label">
                            <div className="ui_inner">
                              <img
                                className="cursor_pointer_custom_cls"
                                onClick={() =>
                                  document
                                    .getElementById(`mse-file`)
                                    .click()
                                }
                                src={upload_icon}
                                alt="Upload"
                              />
                              {/* <h5>{isuploadclinicalinterView? "Uploading" : "Upload"}</h5> */}
                              <h5
                                className="cursor_pointer_custom_cls"
                                onClick={() =>
                                  document
                                    .getElementById(`mse-file`)
                                    .click()
                                }
                              >
                                {isuploadmse
                                  ? "Uploading"
                                  : "Upload"}{" "}
                                {isuploadmse && (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                              </h5>
                              <p>
                                <span>Browse</span> to upload the file
                              </p>
                            </div>
                          </label>
                        </div>

                        {uploadedRecordSession?.mse && (
                          <>
                            <div className="record_seesion_info">
                              <p className="sm_txt">
                                <strong>
                                  {createShortNameFile(
                                    uploadedRecordSession?.mse
                                  )}
                                </strong>
                              </p>
                              <a
                                href={`${uploadedRecordSession.mse}`} // Full URL for S3 file
                                target="_blank" // Opens link in a new tab
                                rel="noopener noreferrer" // Security best practice
                                className="edit"
                              >
                                <i className="fa-solid fa-eye"></i>
                              </a>
                            </div>
                          </>
                        )}
                        {audioMse ? (
                          <>
                            <p className="sm_txt">
                              <strong>{audioMse.name}</strong>
                            </p>
                          </>
                        ) : (
                          <p className="sm_txt">
                            Supported file formats are{" "}
                            <strong>MP3, WAV, M4A, PDF.</strong>
                          </p>
                        )}
                        {uploadedRecordSeesion?.find(
                          (item) =>
                            item.session_type === 'mse' &&
                            item.transcription_text &&
                            item.transcription_text !== ''
                        ) && (
                            <p className="sm_txt mt-2 mb-2 text-success">
                              A Mse interview has already been uploaded.
                              {/* Uploading a new file will replace the existing one. */}
                            </p>
                          )}
                        {getErros?.mse && (
                          <div className="errors-from">
                            {getErros?.mse}
                          </div>
                        )}
                      </div>
                    </div>


                    <div className="col-md-12">
                      {getUploadedReport && getUploadedReport.length > 0 && (
                        <>
                          <strong>Reports Docs:</strong>
                          {/* {JSON.stringify(getUploadedReport)} */}
                          <div className="allreports_block">
                            {getUploadedReport.map((item, index) => (
                              <>
                                <div className="allreports-inner mt-1">
                                  <p key={index}>
                                    <a href={item.file} target="_blank">
                                      {createShortNameFile(item.file)}
                                    </a>
                                  </p>
                                  <button
                                    class="edit"
                                    onClick={(e) =>
                                      handledeleteFile(e, item.id)
                                    }
                                  >
                                    <i class="fa-solid fa-remove"></i>
                                  </button>
                                </div>
                              </>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}

                <div className="field_block mt-4">
                  <div className="btn_row">
                    <button
                      disabled={isDocsLoading || isSubmit}
                      onClick={handleSubmit}
                    >
                      <span>Submit</span> <img src={rightArrow} alt="Arrow" />{" "}
                      {isSubmit && (
                        <>
                          {""}
                          <LoaderIndex />
                        </>
                      )}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>
      {/* <ToastContainer /> */}
    </>
  );
}


function AudioRecordModal({ onsuccess, isSubmitting, ...props }) {
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [audioURL, setAudioURL] = useState(null);
  const [mp3URL, setMp3URL] = useState(null); // ✅ ADDED
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [audioType, setAudioType] = useState("");

  const [audioTypeError, setAudioTypeError] = useState(""); // ✅ ADDED: validation error state

  const streamRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }

      // ✅ ADDED: Cleanup blobs on unmount
      if (audioURL) URL.revokeObjectURL(audioURL);
      if (mp3URL) URL.revokeObjectURL(mp3URL);
    };
  }, []);

  const startRecording = async () => {
    if (mediaRecorder && mediaRecorder.state === "paused") {
      mediaRecorder.resume();
      setIsPaused(false);
      return;
    }

    if (mediaRecorder) return;

    resetRecording();

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;

    const recorder = new MediaRecorder(stream);
    setMediaRecorder(recorder);
    setAudioChunks([]);
    setIsRecording(true);
    setIsPaused(false);

    recorder.ondataavailable = e => {
      if (e.data.size > 0) {
        setAudioChunks(prev => [...prev, e.data]);
      }
    };

    recorder.start(1000);
  };

  const pauseRecording = async () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.pause();
      setIsPaused(true);

      // ✅ MODIFIED: Generate WebM audio
      const blob = new Blob(audioChunks, { type: "audio/webm" });
      const url = URL.createObjectURL(blob);
      setAudioURL(url);

      // ✅ ADDED: Convert to MP3 and store URL
      try {
        const mp3Blob = await convertWebmToMp3(blob);
        const mp3ObjectUrl = URL.createObjectURL(mp3Blob);
        setMp3URL(mp3ObjectUrl);
      } catch (err) {
        console.error("MP3 conversion failed", err);
      }

      setTimeout(() => {
        if (audioRef.current) {
          audioRef.current.load();
        }
      }, 100);
    }
  };

  const resetRecording = () => {
    // ✅ ADDED: Clean up object URLs
    if (audioURL) URL.revokeObjectURL(audioURL);
    if (mp3URL) URL.revokeObjectURL(mp3URL);

    setAudioURL(null);
    setMp3URL(null); // ✅ ADDED
    setAudioChunks([]);
    setMediaRecorder(null);
    setIsRecording(false);
    setIsPaused(false);

    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
  };

  return (
    <Modal {...props} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Record Audio</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <section className="patient_form_block">
          <div className="text-center mb-4">
            <h5>Audio Recording Section</h5>

            {isRecording && !isPaused && (
              <div className="my-3">
                <img
                  src={mutemic}
                  alt="Recording..."
                  style={{ width: "80px", animation: "pulse 1.5s infinite ease-in-out" }}
                />
                <p style={{ marginTop: "0.5rem", fontWeight: 500 }}>Listening...</p>
              </div>
            )}

            <div className="d-flex justify-content-center align-items-center flex-wrap gap-3 mt-3">
              {!isRecording && (
                <button
                  onClick={startRecording}
                  className="btn btn-primary px-4 py-2 fw-bold rounded-3"
                >
                  Start Recording
                </button>
              )}

              {isRecording && !isPaused && (
                <button
                  onClick={pauseRecording}
                  className="btn btn-warning px-4 py-2 fw-bold rounded-3"
                >
                  Pause Recording
                </button>
              )}

              {isPaused && (
                <button
                  onClick={startRecording}
                  className="btn btn-success px-4 py-2 fw-bold rounded-3"
                >
                  Resume Recording
                </button>
              )}

              {audioURL && (
                <>
                  <audio
                    ref={audioRef}
                    src={audioURL}
                    controls
                    preload="auto"
                    controlsList="nodownload"
                    style={{
                      width: "100%",
                      maxWidth: "400px",
                      borderRadius: "12px",
                      background: "#f8f9fa",
                      padding: "0.4rem"
                    }}
                  />
                  <button
                    onClick={resetRecording}
                    className="btn btn-light px-3 py-2 fw-bold border rounded-3"
                  >
                    Reset
                  </button>
                </>
              )}
            </div>

            {mp3URL && (
              <div className="position-relative"> {/* ✅ ADDED container for row + absolute error */}
                <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 mt-4">
                  <a
                    href={mp3URL}
                    download={`recording_${Date.now()}.mp3`}
                    className="btn btn-secondary px-4 py-2 fw-bold rounded-3"
                  >
                    Download MP3
                  </a>

                  {/* ✅ CHANGED: Wrap select in relative container */}
                  <div style={{ minWidth: "200px", position: "relative" }}>
                    <select
                      className={`form-select ${audioTypeError ? "is-invalid" : ""}`}
                      value={audioType}
                      onChange={(e) => {
                        setAudioType(e.target.value);
                        if (e.target.value !== "") {
                          setAudioTypeError("");
                        }
                      }}
                    >
                      <option value="">Select Audio</option>
                      <option value="clinical_interview">Clinical Interview</option>
                      <option value="formulation">Formulation</option>
                      <option value="mse">MSE</option>
                    </select>

                    {/* ✅ ADDED: Error message directly below dropdown, without shifting */}
                    {audioTypeError && (
                      <div
                        className="text-danger fw-semibold"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: "0",
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {audioTypeError}
                      </div>
                    )}
                  </div>

                  <button
                    className="btn btn-primary px-4 py-2 fw-bold rounded-3"
                    onClick={() => {
                      if (audioType === "") { // ✅ VALIDATION
                        setAudioTypeError("Please select a valid audio type.");
                        return;
                      }
                      setAudioTypeError(""); // ✅ clear error
                      onsuccess(new Blob(audioChunks, { type: "audio/webm" }), audioType, props.patientid);
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        Submit <LoaderIndex />
                      </>
                    ) : (
                      <>
                        Submit <span className="ms-2">&rarr;</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
}



const PatientInformationPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selector = useSelector(
    (state) => state.GET_PATIENT_INFORMATION_REDUCER
  );
  const [modalShow, setModalShow] = React.useState(false);
  const [audioModalShow, setAudioModalShow] = React.useState(false);
  const [currentPatientId, setCurrentPatientId] = React.useState(null);
  const [currentPatientInformation, setCurrentPatientInformation] =
    React.useState([]);

  const [count, setCount] = React.useState(0);
  const [list, setList] = React.useState([]);
  const onHide = () => setModalShow(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingReports, setLoadingReports] = useState({});
  const [deletePatientids, setDeletePatient] = useState({});
  // const patientMedicineRecommendationSelector = useSelector((state) => state.GET_PATIENT_MEDICINE_RECOMMENDATION_REDUCER)
  // const patientReportSelector = useSelector((state) => state.GET_PATIENT_REPORT_REDUCER)
  const [promptResult, setPromptResult] = useState([]);
  const [isGetRecommendation, setIsGetRecommendation] = useState(false);
  const [isGetSummaryReport, setIsGetSummaryReport] = useState(false);
  const [recommendationDeatil, setRecommendationDeatil] = React.useState("");
  const [promptTextChange, setPromptTextChange] = useState(false);
  const [isUpadatedPrompt, setUpdatedPrompt] = useState(false);
  const [recommendationModalShow, setRecommendationModalShow] = useState(false);
  const [summarynModalShow, setSummaryModalShow] = useState(false);
  const [summaryReport, setSummaryReport] = React.useState("");
  const [selectedRecommendationPatId, setSelectedRecommendationPatId] = useState(null);
  const [templateModal, setTemplateModal] = useState(false);
  const [templateModalClaude, setTemplateModalClaude] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userData, setUserData] = useState(null);
  const [open, setOpen] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [paitent, setSelectedPaitent] = useState(null)
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const fetchUser = async () => {
      const isTokenAvailable = localStorage.getItem("accessToken");

      if (isTokenAvailable) {
        const header = {
          headers: {
            Authorization: `Bearer ${isTokenAvailable}`,
          },
        };

        try {
          const response = await axios.get(GET_USER, header);
          if (response.status === 200 || response.status === 201) {
            console.log("User data:", response.data.data);

            setUserData(response?.data?.data); //
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      }
    };

    fetchUser();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    getPatientInformationNew();
    // getPatientInformation();
    getProptsDeatils();
  }, []);

  const getProptsDeatils = async () => {
    setIsGetRecommendation(true);
    try {
      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        //  setIsProptsApiCall(true);
        setPromptResult(response.res.data.data);
      }
      setIsGetRecommendation(false);
    } catch (error) {

    }
  }

  const getPatientInformation = () => {
    if (selector.error === null) {
      if (selector.data === null) {
        dispatch(patientInformation());
      }
    }
  };
  const getPatientInformationNew = async () => {
    setIsLoading(true);
    try {
      const response = await CallWithAuth("GET", PATIENT_INFORMATION_API_URL);
      // console.log(response?.res?.data?.data);
      if (response?.res?.data?.statusCode === 200) {
        // console.log("840");
        setList(response?.res?.data?.data);
      } else {
        setList([]);
      }
    } catch (error) { }
    setIsLoading(false);
  };

  const handleOpenDoCModal = async (patientId, patientDetails) => {
    // console.log("patientId", patientId);
    // console.log("patientDetails", patientDetails);

    setCount(count + 1);
    setModalShow(true);
    setCurrentPatientId(patientId);
    setCurrentPatientInformation(patientDetails);
    // console.log('patientInformation=====>',patientDetails);
  };

  const handleOpenRecordAudioModal = (patientId, patientDetails) => {
    setCurrentPatientId(patientId);
    setCurrentPatientInformation(patientDetails);
    setAudioModalShow(true); // this will trigger the modal to open
  };

  const handleClickReleativesPageRedirect = async (patientId) => {
    navigate(`/${PATIENTRELATIVESINFORMATION}/${patientId}`);
  };
  const handleSuccess = async () => {
    // getPatientInformationNew(); // console.log("825");
    setCurrentPatientId(null);
    // toast.success("Patient file updated successfully.", {
    //   autoClose: 2000,
    //   position: "bottom-right",
    // })
    try {
      const response = await CallWithAuth("GET", PATIENT_INFORMATION_API_URL);
      // console.log(response?.res?.data?.data);
      if (response?.res?.data?.statusCode === 200) {
        // console.log("840");
        setList(response?.res?.data?.data);
      } else {
        setList([]);
      }
    } catch (error) { }

    toast.success("Patient file updated successfully.", {
      autoClose: 2000,
      position: "top-right",
    });
  };

  const handleAudioSubmit = async (blob, audioType, patientId) => {
    setIsSubmitting(true);
    const mp3Blob = await convertWebmToMp3(blob);
    const formData = new FormData();
    formData.append("file", mp3Blob, "recording.mp3");
    formData.append("type", audioType);

    try {
      const response = await CallWithAuth("POST", `${PATIENT_AUDIO_API_URL}${patientId}`, formData);

      if (response?.res?.data?.statusCode === 200) {
        const patientInfoResponse = await CallWithAuth("GET", PATIENT_INFORMATION_API_URL);
        if (patientInfoResponse?.res?.data?.statusCode === 200) {
          setList(patientInfoResponse.res.data.data); // Set list with patient info only
          setAudioModalShow(false);
        }

        toast.success("Patient file updated successfully.", {
          autoClose: 2000,
          position: "bottom-right"
        });
      } else {
        toast.error("Audio upload failed.");
      }
    } catch (error) {
      toast.error("Failed to upload audio.");
    } finally {
      setIsSubmitting(false); // ✅ Reset loading state
    }
  };


  const handleClickDetailPageOpen = async (patientId, record_sessions) => {
    // try {
    //   setLoadingReports((prev) => ({ ...prev, [patientId]: true }));
    //   const response = await CallWithAuth(
    //     "GET",
    //     `${CHECK_PATIENT_REPORT_STATUS}/${patientId}`
    //   );
    //   // console.log(response?.res?.data?.data);
    //   if (response?.res?.data?.statusCode === 200) {
    //     // console.log("840");
    //     navigate(`/patient-report-information/${patientId}`);
    //   } else {
    //     toast.info(response?.res?.data?.message != 'Patient intake form is not submitted yet' ? "Please wait while the transcription text is being generated" : response?.res?.data?.message, {
    //       autoClose: 2000,
    //       position: "bottom-right",
    //     });
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
    navigate(`/patient-report-information/${patientId}`);
    setLoadingReports((prev) => ({ ...prev, [patientId]: false }));

    console.log("patientId", patientId);

    // navigate(`/patient-report-information/${patientId}`);
  };

  const handleDeletePatient = async (patientId) => {
    const result = await MySwal.fire({
      title: "Are you sure want to delete Patient's?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        setDeletePatient((prev) => ({ ...prev, [patientId]: true }));

        const response = await CallWithAuth(
          "DELETE",
          `${DELETE_PATIENT}/${patientId}`
        );
        // console.log(response?.res?.data?.data);
        if (response?.res?.data?.statusCode === 200) {
          try {
            const response = await CallWithAuth(
              "GET",
              PATIENT_INFORMATION_API_URL
            );
            if (response?.res?.data?.statusCode === 200) {
              setList(response?.res?.data?.data);
            } else {
              setList([]);
            }
            setDeletePatient((prev) => ({ ...prev, [patientId]: false }));
          } catch (error) {
            setDeletePatient((prev) => ({ ...prev, [patientId]: false }));
          }

          toast.success("Patient deleted Successfully.", {
            autoClose: 2000,
            position: "bottom-right",
          });
        } else {
          toast.error(response?.res?.data?.message, {
            autoClose: 2000,
            position: "bottom-right",
          });
          setDeletePatient((prev) => ({ ...prev, [patientId]: false }));
        }
      } catch (error) {
        console.log(error);
        setDeletePatient((prev) => ({ ...prev, [patientId]: false }));
      }
    }
  };
  const handleClickAssessmentPageOpen = (patientId) => {
    // console.log("patientId", patientId);
    // navigate(`/${PATIENTRELATIVESINFORMATION}/${patientId}`);

    // return;
    navigate(`/${DOCTORASSESMENTINFORMATIONPAGE}/${patientId}`);
    // navigate(`/${DOCTORASSESMENTINFORMATIONPAGE}/${patientId}`);
  };

  const handleClickRecordingPageOpen = (patientId) => {
    console.log("patientId", patientId);
    navigate(`/${RECORDINGINFORMATIONPAGE}/${patientId}`);
  };

  const handleClickMailSendOpen = async (patientId) => {
    // console.log("patientId", patientId);
    // navigate(`/${PATIENTRELATIVESINFORMATION}/${patientId}`);
    const result = await MySwal.fire({
      title: "Are you sure want to send email Patient's?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
    });
    if (result.isConfirmed) {
      try {
        const response = await CallWithAuth(
          "GET",
          `${PATIENT_INTAKE_FROM_RESEND}/${patientId}`
        );
        if (response?.res?.data?.statusCode === 200) {
          // console.log("840");
          toast.success(response?.res?.data?.message, {
            autoClose: 2000,
            position: "bottom-right",
          });
        } else {
          if (response?.res?.data?.statusCode === 403) {
            toast.error('You need an active subscription to use this feature. Please check your subscription status.', {
              autoClose: 5000,
              position: "bottom-right",
            });
          } else {
            toast.error(response?.res?.data?.message, {
              autoClose: 5000,
              position: "bottom-right",
            });
          }

        }
      } catch (error) {
        console.log(error);
      }
      // console.log("patientId", patientId);
    }
  };

  const streamCallWithAuth = async (url, body, options = {}) => {
    const token = localStorage.getItem('accessToken'); // Or however you get your auth token
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(body),
      signal: options.signal
    });
  };

  const handleGetRecommendation = async (patient) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const { signal } = controller;

    setIsGetRecommendation(true);
    const findPropmts = promptResult.find((item) => item.apiEndpointName === 'recommendation');

    if (findPropmts === undefined) {
      setIsGetRecommendation(false);
      showToast("error", "Prompt is missing. Please contact admin for further instruction");
      return;
    }

    try {
      const response = await streamCallWithAuth(`${PATIENT_ASSESSMWNT_RECOMMENDED_STREAM}${patient?.id}`, {
        prompt_text: findPropmts?.promtText
      }, { signal });
  
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let accumulatedText = "";
  
      while (true) {
        const { value, done } = await reader.read();
  
        const chunk = decoder.decode(value, { stream: true });
  
        let resp = null;
        try {
          resp = JSON.parse(chunk);
        } catch (e) { }
  
        if (resp?.error) {
          showToast("error", resp.message);
          break
        }
  
        if (done) {
          break;
        }
  
        // 3. Parse SSE format (data: {"chunk": "..."})
        const lines = chunk.split("\n\n");
        lines.forEach(line => {
          if (line.startsWith("data: ")) {
            try {
              const data = JSON.parse(line.replace("data: ", ""));
  
              if (data.chunk) {
                accumulatedText += data.chunk.replaceAll("data: ", "").replaceAll("\n\ndata: ", "").replace(/\n\n$/, '');
                setRecommendationDeatil(accumulatedText);
              }
  
              setPromptTextChange(findPropmts?.promtText);
              setRecommendationModalShow(true);
              setSelectedRecommendationPatId(patient?.id);
  
              if (data.status === 'done') {
                console.log("Streaming complete");
              }
            } catch (e) {
              console.log(e);
              console.error("Error parsing stream chunk", e);
            }
          }
        });
      }

    } catch (error) {

    } finally {
      abortControllerRef.current = null;
    }

    setIsGetRecommendation(false);
  };

  const handleGetSummary = async (patient) => {

    // setSummaryModalShow(true); return
    setIsGetSummaryReport(true);

    try {
      // const findPropmts = promptResult.find((item) => item.apiEndpointName === 'reportsummary');
      // // console.log("findPropmts==>", findPropmts);

      // if (findPropmts === undefined) {
      //   showToast("error", "No endpoint found for the selected prompt.");
      //   return;
      // }
      let response = await CallWithAuth(
        "GET",
        `${PATIENT_ASSESSMWNT_SUMMARY}${patient?.id}`,
      );
      let message = errorMessageCreate(response?.res?.data?.message);
      // console.log("response==>sdf", response?.res?.data);

      if (response?.res?.data?.statusCode === 200) {
        setSummaryReport(response.res.data.data.summary_text || '');
        setIsGetSummaryReport(false);
        setSummaryModalShow(true);
      } else {
        showToast("error", message);
        setSummaryReport('');
        setIsGetSummaryReport(false);
      }

    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseRecommendationModal = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    setIsGetRecommendation(false);
    setRecommendationModalShow(false);
    closeModal();
  };
  const handleCloseSummaryModal = () => {
    setSummaryModalShow(false);
    closeModal()
  }

  const handlePromptInputChange = (fieldName, value) => {
    setPromptTextChange(value)
  }
  const handleTestPrompt = async (reportData, field) => {
    // setPromptTextChange(reportData)
    // console.log("reportData==>", reportData);

    setRecommendationDeatil(reportData);
  }
  const handleUpdatePrompt = async (reportData, field, promptValue) => {
    setRecommendationDeatil(reportData);
    try {
      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        //  setIsProptsApiCall(true);
        setPromptResult(response.res.data.data);
      }
      setIsLoading(false);
    } catch (error) {

    }
  }
  const handleChangePrompt = async () => {
    setUpdatedPrompt(isUpadatedPrompt ? false : true);
  }

  const handleReset = async (fieldName, value) => {
    setPromptTextChange(value?.promtText);
    try {
      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        //  setIsProptsApiCall(true);
        setPromptResult(response.res.data.data);
        setUpdatedPrompt(false);

      }
      setIsLoading(false);
    } catch (error) {

    }
  }

  const handleClickChkSub = (e) => {
    if (userData?.subscription === null) {
      e.preventDefault(); // stop navigation
      setOpen(true);      // open modal
    }
  };
  const [viewType, setViewType] = useState('list');


  const getTemplateData = async () => {
    try {
      const response = await CallWithAuth("GET", ADMINTEMPLATE);
      if (response.res.status == 200) {
        setTemplateList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
    } catch (err) {
      console.log(err)
    }
  };
  useEffect(() => {
    getTemplateData();
  }, []);

  const closeModal = () => {
    setTimeout(() => {
      console.log('Closing modal');
      document.querySelector('body').removeAttribute('style');
    }, 500);
  };

  return (
    <>
      {recommendationModalShow && (
        <Modal show={recommendationModalShow} onHide={handleCloseRecommendationModal} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Recommendation Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                fontSize: "20px",
                padding: "15px",
                background: "#F9FAFC",
                borderRadius: "10px",
                width: "100%",
              }}
              className="form-group report-container-new"
              dangerouslySetInnerHTML={{
                // __html: marked(reportgenerateData.collateral??""),
                __html: safeMarkedWrapper(marked(recommendationDeatil) ?? ""),
              }}
            />

            {isUpadatedPrompt ? (
              <PromptEditor
                field="recommendation"
                promptValue={promptTextChange || ""}
                onChange={handlePromptInputChange}
                onTest={handleTestPrompt}
                onUpdate={handleUpdatePrompt}
                onCancel={handleChangePrompt}
                onReset={handleReset}
                cancelValue={promptTextChange}
                promptResult={promptResult}
                id={selectedRecommendationPatId}
              />) : (

              <button
                className="btn btn-primary"
                onClick={(e) =>
                  handleChangePrompt(
                  )
                }
              // disabled={isUpadatedPrompt}
              >
                Edit Prompts
              </button>)
            }

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseRecommendationModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
      }
      {/* Start Report Summary Modal */}

      {summarynModalShow && (
        <Modal show={summarynModalShow} onHide={handleCloseSummaryModal} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Summary Report Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {summaryReport?.trim() ? (
              <div
                style={{
                  fontSize: "20px",
                  padding: "15px",
                  background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  __html: safeMarkedWrapper(marked(summaryReport) ?? ""),
                }}
              />
            ) : (
              <div
                style={{
                  fontSize: "20px",
                  padding: "15px",
                  background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                  color: "#999",
                  textAlign: "center",
                }}
                className="form-group report-container-new"
              >
                No summary report data available.
              </div>
            )}

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSummaryModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
      }

      {/* End Report Summary Modal */}
      {/* {modalShow && (
        <>
          <MyVerticallyCenteredModal
            show={modalShow}
            count={count}
            onHide={onHide}
            patientid={currentPatientId}
            onsuccess={handleSuccess} // Pass success handler
            patientInformation={currentPatientInformation}
          />
        </>
      )} */}

      {modalShow && (
        <UploadReportModal
          show={modalShow}
          onHide={() => { setModalShow(false); closeModal(); }}
          patientid={currentPatientId}
          onSuccess={(data) => {
            console.log("Uploaded File Data:", data);
            // Call your API upload here
            handleSuccess(data);
          }}
        />
      )}

      {audioModalShow && (
        <>
          <AudioRecordModal
            show={audioModalShow}
            // count={count}
            onHide={() => { setAudioModalShow(false); closeModal(); }}
            backdrop="static"
            controlsList="nodownload"
            patientid={currentPatientId}
            isSubmitting={isSubmitting}
            // patientInformation={currentPatientInformation}
            onsuccess={handleAudioSubmit}
          />
        </>
      )}

      {/* ✅ Subscription Modal */}
      {open && (
        <Modal show={open} onHide={() => { setOpen(false); closeModal(); }} centered size="md">
          <Modal.Header closeButton>
            <Modal.Title>No Active Subscription</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: "center" }}>
            <h5>You don’t have any active subscription plan</h5>
            <p>Please subscribe to a plan to add patients.</p>
            <Button
              variant="primary"
              onClick={() => {
                setOpen(false);
                navigate("/subscription");
              }}
            >
              Subscribe Now
            </Button>
          </Modal.Body>
        </Modal>
      )}


      {(isLoading || isGetRecommendation || isGetSummaryReport) && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}
      <>

        <div className="front-end-dashboard">
          <div className="site_container">
            {/* start: dashboard-page-header */}
            <div className="dashboard-page-header">
              <div className="left-div">
                <h3>Manage Patient File</h3>
              </div>
              <div className="right-div">
                <button type="button" className={`list-view-type ${viewType == 'list' && 'active'}`} onClick={() => setViewType('list')}><BsList /></button>
                <button type="button" className={`list-view-type ${viewType == 'grid' && 'active'}`} onClick={() => setViewType('grid')}><RxDashboard /></button>
                <Link
                  to={"/manage-patient"}
                  className="solid_cta cta_primary cta_with_icon addbtn responsive-icon-btn"
                  onClick={handleClickChkSub}
                >
                  <span className="btn-icon"><IoMdAdd /></span>
                  <span className="btn-text">Add Patient</span>
                </Link>
              </div>
            </div>
            {/* end: dashboard-page-header */}



            {/* start: dashboard-page-body */}
            <div className="dashboard-page-body">
              {/* list view */}
              {viewType == 'list' &&
                <div className="patient_form_block bg_light_gray">
                  <div className="table-responsive">
                    <table className="table patient-row-details m-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>Date of birth</th>
                          <th>File Uploaded</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list?.length && !isLoading
                          ? list?.map((patient, index) => (
                            <tr key={index}>
                              <td>
                                <div className="td-userName-img">
                                  <div className="icon-container">
                                    {patient.full_name?.split(' ')?.map(word => word[0])?.join('') || ''}
                                  </div>
                                  <div className="text-container">{patient.full_name}</div>
                                </div>
                              </td>
                              <td>
                                <>{patient.email}</>
                              </td>
                              <td>
                                <>{patient.phone}</>
                              </td>
                              <td>
                                <>{patient.dob.split("T")[0]}</>
                              </td>
                              <td>
                                <div className={patient.record_sessions.length > 0 ? "td-uploaded-file-status yes" : "td-uploaded-file-status no"}>
                                  <div className="status-icon">
                                    {patient.record_sessions.length > 0 ? <IoCheckmarkDoneOutline /> : <AiOutlineClose />}
                                  </div>
                                  <div className="status-text">{patient.record_sessions.length > 0
                                    ? "Yes"
                                    : "No"}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <PopupState variant="popover" popupId="demo-popup-menu">
                                  {(popupState) => (
                                    <>
                                      <button type="button" className="more-action-btn" {...bindTrigger(popupState)}>
                                        <IoMdMore />
                                      </button>
                                      <Menu {...bindMenu(popupState)} className='theme-menu-dropdown-s1'
                                        anchorOrigin={{
                                          vertical: 'bottom',
                                          horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                          vertical: 'top',
                                          horizontal: 'right',
                                        }}>
                                        <MenuItem
                                          onClick={() => { popupState.close(); handleClickAssessmentPageOpen(patient?.id) }}
                                        >
                                          <Box className="icon-container"><FaUserInjured /></Box>
                                          <Box className="text-container">Patient Assesment</Box>
                                        </MenuItem>
                                        {patient?.is_form_submitted && (
                                          <>
                                            <MenuItem
                                              onClick={() => { popupState.close(); handleGetRecommendation(patient) }}
                                            >
                                              <Box className="icon-container"><MdOutlineRecommend /></Box>
                                              <Box className="text-container">Suggestions</Box>
                                            </MenuItem>
                                          </>
                                        )}
                                        <MenuItem
                                          disabled={loadingReports?.[patient?.id]}
                                          onClick={() => {
                                            popupState.close(); 
                                            if (!localStorage.getItem("userCreateAccountInfo") || localStorage.getItem("userCreateAccountInfo") === "null") {
                                              showToast("error", "Profile not set. Please setup your profile to continue");
                                              return;
                                            }
                                            handleClickDetailPageOpen(
                                              patient?.id,
                                              patient?.record_sessions
                                            )
                                          }}
                                        >
                                          <Box className="icon-container">
                                            <img src={reportIcon} alt="" />
                                          </Box>
                                          <Box className="text-container">
                                            Report
                                            {loadingReports?.[patient?.id] && (
                                              <LoaderIndex />
                                            )}
                                          </Box>
                                        </MenuItem>
                                        <MenuItem
                                          disabled={loadingReports?.[patient?.id]}
                                          onClick={() => {
                                            popupState.close();
                                            if (!localStorage.getItem("userCreateAccountInfo") || localStorage.getItem("userCreateAccountInfo") === "null") {
                                              showToast("error", "Profile not set. Please setup your profile to continue");
                                              return;
                                            }
                                            setTemplateModal(true);
                                            setSelectedPaitent(patient);
                                          }}
                                        >
                                          <Box className="icon-container">
                                            <img src={reportIcon} alt="" />
                                          </Box>
                                          <Box className="text-container">
                                            Report Templates
                                            {loadingReports?.[patient?.id] && (
                                              <LoaderIndex />
                                            )}
                                          </Box>
                                        </MenuItem>
                                        <MenuItem
                                          disabled={loadingReports?.[patient?.id]}
                                          onClick={() => {
                                            popupState.close();
                                            if (!localStorage.getItem("userCreateAccountInfo") || localStorage.getItem("userCreateAccountInfo") === "null") {
                                              showToast("error", "Profile not set. Please setup your profile to continue");
                                              return;
                                            }
                                            setTemplateModalClaude(true);
                                            setSelectedPaitent(patient);
                                          }}
                                        >
                                          <Box className="icon-container">
                                            <img src={reportIcon} alt="" />
                                          </Box>
                                          <Box className="text-container">
                                            Report Claude
                                            {loadingReports?.[patient?.id] && (
                                              <LoaderIndex />
                                            )}
                                          </Box>
                                        </MenuItem>
                                        {!patient?.is_form_submitted && (
                                          <>
                                            <MenuItem
                                              onClick={() => { popupState.close(); handleClickMailSendOpen(patient?.id) }}
                                            >
                                              <Box className="icon-container"><TbSend /></Box>
                                              <Box className="text-container">Resend Mail</Box>
                                            </MenuItem>
                                          </>
                                        )}

                                        <MenuItem
                                          onClick={() => { popupState.close(); handleClickReleativesPageRedirect(patient?.id) }}
                                        >
                                          <Box className="icon-container"><SiSecurityscorecard /></Box>
                                          <Box className="text-container">Collateral</Box>
                                        </MenuItem>
                                        <MenuItem
                                          onClick={() => { popupState.close(); handleGetSummary(patient) }}

                                        >
                                          <Box className="icon-container"><IoDocumentTextOutline /></Box>
                                          <Box className="text-container">Summary Report</Box>
                                        </MenuItem>

                                        <MenuItem
                                          onClick={() => { popupState.close(); handleClickRecordingPageOpen(patient?.id) }}
                                        >
                                          <Box className="icon-container"><AiOutlineAudio /></Box>
                                          <Box className="text-container">Recording</Box>
                                        </MenuItem>

                                        <MenuItem
                                          onClick={() => { popupState.close(); handleDeletePatient(patient?.id) }}
                                        >
                                          <Box className="icon-container"><MdDeleteOutline /></Box>
                                          <Box className="text-container">Delete</Box>
                                          {deletePatientids?.[patient?.id] && (
                                            <LoaderIndex />
                                          )}
                                        </MenuItem>

                                        <MenuItem
                                          onClick={() => { popupState.close(); handleOpenDoCModal(patient?.id, patient) }}
                                        >
                                          <Box className="icon-container">
                                            <MdOutlineFileUpload />
                                          </Box>
                                          <Box className="text-container">
                                            Upload Report File
                                          </Box>
                                        </MenuItem>

                                        {/* <MenuItem onClick={()=>{popupState.close();navigate('/patient-details')}}>
                                          <Box className="text-container">View</Box>
                                        </MenuItem> */}
                                      </Menu>
                                    </>
                                  )}
                                </PopupState>
                              </td>
                            </tr>
                          ))
                          : null}
                      </tbody>
                    </table>
                    {!isLoading && list.length === 0 && (
                      <h1 style={{ textAlign: "center" }}>No Data Found</h1>
                    )}
                  </div>
                </div>
              }
              {/* grid view */}
              {viewType == 'grid' &&
                <div className="patient-information-gird-view">
                  {list?.length && !isLoading
                    ? list?.map((patient, index) => (
                      <div className="patient-information-item" key={index}>
                        <div className="flip-card">
                          <div className="flip-card-inner">
                            <div className="flip-card-front">
                              <div className="patient-basic-details">
                                <div className="image-container">mp</div>
                                <div className="text-container">
                                  <h4>{patient.full_name}</h4>
                                  <h5><a href={`mailto:${patient.email}`}>{patient.email}</a></h5>
                                </div>
                              </div>
                              <div className="patient-more-details">
                                <div className="details-ul">
                                  <div className="details-li">
                                    <label htmlFor="">Phone Number</label>
                                    <p><a href={`tel:${patient.phone}`}>{patient.phone}</a></p>
                                  </div>
                                  <div className="details-li">
                                    <label htmlFor="">Date of birth</label>
                                    <p>{patient.dob.split("T")[0]}</p>
                                  </div>
                                  <div className="details-li">
                                    <label>File Uploaded</label>
                                    <p>
                                      <div className={patient.record_sessions.length > 0 ? "td-uploaded-file-status yes" : "td-uploaded-file-status no"}>
                                        <div className="status-icon">
                                          {patient.record_sessions.length > 0 ? <IoCheckmarkDoneOutline /> : <AiOutlineClose />}
                                        </div>
                                        <div className="status-text">{patient.record_sessions.length > 0
                                          ? "Yes"
                                          : "No"}
                                        </div>
                                      </div>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flip-card-back">
                              <div className="flip-menu-lists">
                                <button type="button" className="flip-button"
                                  onClick={() => { handleClickAssessmentPageOpen(patient?.id) }}
                                >
                                  <Box className="icon-container"><FaUserInjured /></Box>
                                  <Box className="text-container">Patient Assesment</Box>
                                </button>
                                {patient?.is_form_submitted && (
                                  <>
                                    <button type="button" className="flip-button"
                                      onClick={() => { handleGetRecommendation(patient) }}
                                    >
                                      <Box className="icon-container"><MdOutlineRecommend /></Box>
                                      <Box className="text-container">Recommendations</Box>
                                    </button>
                                  </>
                                )}
                                <button type="button" className="flip-button"
                                  disabled={loadingReports?.[patient?.id]}
                                  onClick={() => {
                                    handleClickDetailPageOpen(
                                      patient?.id,
                                      patient?.record_sessions
                                    )
                                  }}
                                >
                                  <Box className="icon-container">
                                    <img src={reportIcon} alt="" />
                                  </Box>
                                  <Box className="text-container">
                                    Report
                                    {loadingReports?.[patient?.id] && (
                                      <LoaderIndex />
                                    )}
                                  </Box>
                                </button>
                                <button type="button" className="flip-button"
                                >
                                  <Box className="icon-container">
                                    <img src={reportIcon} alt="" />
                                  </Box>
                                  <Box className="text-container">
                                    Report Summery
                                  </Box>
                                </button>
                                {!patient?.is_form_submitted && (
                                  <>
                                    <button type="button" className="flip-button"
                                      onClick={() => { handleClickMailSendOpen(patient?.id) }}
                                    >
                                      <Box className="icon-container"><TbSend /></Box>
                                      <Box className="text-container">Resend Mail</Box>
                                    </button>
                                  </>
                                )}
                                <button type="button" className="flip-button"
                                  onClick={() => { handleClickReleativesPageRedirect(patient?.id) }}
                                >
                                  <Box className="icon-container"><SiSecurityscorecard /></Box>
                                  <Box className="text-container">Collateral</Box>
                                </button>
                                <button type="button" className="flip-button"
                                  onClick={() =>
                                    handleGetSummary(patient)
                                  }
                                >
                                  <Box className="icon-container"><IoDocumentTextOutline /></Box>
                                  <Box className="text-container">Summary Report</Box>
                                </button>
                                <button type="button" className="flip-button"
                                  onClick={() => { handleClickRecordingPageOpen(patient?.id) }}
                                >
                                  <Box className="icon-container"><AiOutlineAudio /></Box>
                                  <Box className="text-container">Recording</Box>
                                </button>
                                <button type="button" className="flip-button"
                                  onClick={() => { handleDeletePatient(patient?.id) }}
                                >
                                  <Box className="icon-container"><MdDeleteOutline /></Box>
                                  <Box className="text-container">Delete</Box>
                                  {deletePatientids?.[patient?.id] && (
                                    <LoaderIndex />
                                  )}
                                </button>
                                <button type="button" className="flip-button"
                                  onClick={() => { handleOpenDoCModal(patient?.id, patient) }}
                                >
                                  <Box className="icon-container">
                                    <MdOutlineFileUpload />
                                  </Box>
                                  <Box className="text-container">
                                    Upload Report File
                                  </Box>
                                </button>
                                {/* <MenuItem onClick={()=>{navigate('/patient-details')}}>
                                          <Box className="text-container">View</Box>
                                        </MenuItem> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                    : null}
                </div>
              }
            </div>
            {/* end: dashboard-page-body */}
          </div>
        </div>
      </>

      {/* start: choose-template-modal */}
      <Modal show={templateModal} onHide={() => { setTemplateModal(false); closeModal();  }} scrollable centered className="choose-template-modal">
        <Modal.Header closeButton>
          <Modal.Title>Generate Template for <strong>{paitent?.full_name}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Choose one of the template</h4>
          <div className="template-lists">
            {
              templateList.length > 0 && templateList.map((item, index) => {
                return (
                  <div className="template-item">
                    <button type="button" className="template-btn" key={index}
                      onClick={() => { navigate(`/patient-report-information-template/${paitent?.id}?templateId=${item?.id}`); }}
                    >
                      <span className="icon"><HiOutlineTemplate /></span>
                      <span className="text">{item?.template_name}</span>
                    </button>
                  </div>
                )
              })
            }

          </div>
        </Modal.Body>
      </Modal>
      {/* end: choose-template-modal */}

      {/* start: choose-template-modal-claude */}
      <Modal show={templateModalClaude} onHide={() => { setTemplateModalClaude(false); closeModal();  }} scrollable centered className="choose-template-modal">
        <Modal.Header closeButton>
          <Modal.Title>Generate Template for <strong>{paitent?.full_name}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Choose one of the template</h4>
          <div className="template-lists">
            {
              templateList.length > 0 && templateList.map((item, index) => {
                return (
                  <div className="template-item">
                    <button type="button" className="template-btn" key={index}
                      onClick={() => { navigate(`/patient-report-information-template-claude/${paitent?.id}?templateId=${item?.id}`); }}
                    >
                      <span className="icon"><HiOutlineTemplate /></span>
                      <span className="text">{item?.template_name}</span>
                    </button>
                  </div>
                )
              })
            }

          </div>
        </Modal.Body>
      </Modal>
      {/* end: choose-template-modal */}

    </>
  );
};

export default PatientInformationPage;
